{
  "dateFormats": {
    "age": "{{ date, age }}",
    "dayNumberShortDay": "{{ date, dayNumberShortDay }}",
    "longMonth": "{{ date, longMonth }}",
    "monthYear": "{{ date, monthYear }}",
    "shortMonth": "{{ date, shortMonth }}",
    "shortMonthDay": "{{ date, shortMonthDay }}",
    "shortMonthDayYear": "{{ date, shortMonthDayYear }}",
    "time": "{{ date, time }}",
    "dayShortMonthDay": "{{ date, dayShortMonthDay }}",
    "dayShortMonthDayYear": "{{ date, dayShortMonthDayYear }}",
    "dayNumber": "{{ date, dayNumber }}",
    "dayShort": "{{ date, dayShort }}",
    "dateTime": "{{ date, dateTime }}"
  },
  "Failed to load data.": "Failed to load data.",
  "Failed to load users data.": "Failed to load user data.",
  "Event was created.": "Event was created.",
  "Failed to create event.": "Failed to create event.",
  "Event was updated.": "Event was updated.",
  "Failed to edit event.": "Failed to edit event.",
  "Create program": "Create program",
  "Edit program": "Edit program",
  "Something went wrong, please try again later.": "Something went wrong, please try again later.",
  "Something went wrong, kudo cannot be edited.": "Something went wrong, kudo cannot be edited.",
  "If you are experiencing issues when creating new content, please turn off autocorrect on your device in order to use": "If you are experiencing issues when creating new content, please turn off autocorrect on your device in order to use it",
  "Cancel": "Cancel",
  "Don't show me this warning anymore": "Don't show me this warning anymore",
  "Terms and Conditions": "Terms and Conditions",
  "Do you wish to discard changes?": "Do you wish to discard changes?",
  "Terms title": "Terms title",
  "Terms description": "Terms description",
  "Privacy title": "Privacy title",
  "Privacy description": "Privacy description",
  "Privacy url": "Privacy URL",
  "Image has to be (1920x3840)": "Image has to be (1920x3840)",
  "Are you sure?": "Are you sure?",
  "Name": "Name",
  "Type": "Type",
  "Date Modified": "Date Modified",
  "Size": "Size",
  "No files": "No files",
  "Delete": "Delete",
  "Rename": "Rename",
  "by": "by",
  "Folder name": "Folder name",
  "Create Folder": "Create Folder",
  "No Results Found": "No Results Found",
  "Giving": "Giving",
  "All": "All",
  "Apply": "Apply",
  "Giving finished": "Giving finished",
  "Link has been copied to clipboard": "Link has been copied to clipboard",
  "Goal": "Goal",
  "Raised": "raised",
  "To Go": "To Go",
  "Close": "Close",
  "Country": "Country",
  "State": "State",
  "One time": "One time",
  "Monthly": "Monthly",
  "Quarterly": "Quarterly",
  "Annually": "Annually",
  "Card Details and Card Holder Details": "Card Details and Cardholder Details",
  "Card Details": "Card Details",
  "Card Holder Details": "Cardholder Details",
  "First name": "First name",
  "Last name": "Last name",
  "Email": "Email",
  "Street": "Street",
  "City": "City",
  "ZIP": "ZIP",
  "If you would like to donate by check please mail to:<br /> BigHeart Philanthropy<br /> {{ street }} {{ apt }}, {{ city }}, {{ state }} {{ zip }}": "If you would like to donate by check please mail to:<br /> BigHeart Philanthropy<br /> {{ street }} {{ apt }}, {{ city }}, {{ state }} {{ zip }}",
  "If you would like to set up a recurring donation, please sign up on  <1>this link</1>.": "If you would like to set up a recurring donation, please sign up on  <1>this link</1>.",
  "one time": "one time",
  "monthly": "monthly",
  "quarterly": "quarterly",
  "annually": "annually",
  "Share": "Share",
  "Your <1></1> donation<3></3>of <6></6> is a success!": "Your <1></1> donation<3></3>of <6></6> is a success!",
  "Thank you for your generous gift and supporting our {{ name }} family": "Thank you for your generous gift and supporting our {{ name }} family",
  "To cancel or change your recurring donation to the BigHeart Philanthropy, please email <2></2>": "To cancel or change your recurring donation to the BigHeart Philanthropy, please email <2></2>",
  "Current password": "Current password",
  "New password": "New password",
  "Change Password": "Change Password",
  "Password was successfully updated.": "Password was successfully updated.",
  "Amount": "Amount",
  "First Name": "First Name",
  "Last Name": "Last Name",
  "E-mail": "E-mail",
  "Submit": "Submit",
  "Edit": "Edit",
  "Reply": "Reply",
  "Report": "Report",
  "Attachments": "Attachments",
  "Comment...": "Comment...",
  "See more comments": "See more comments",
  "You are about to delete this community. By deleting this community, you will also delete all of the community's associated content. Are you sure you want to delete this community?": "You are about to delete this community. By deleting this community, you will also delete all of the community's associated content. Are you sure you want to delete this community?",
  "Are you sure you want to delete this community? If you continue, the community will be permanently deleted. No content related to the community can be recovered.": "Are you sure you want to delete this community? If you continue, the community will be permanently deleted. All content related to the community cannot be recovered.",
  "Name of the community": "Name of the community",
  "Description": "Description",
  "Search User": "Search User",
  "Newsfeed": "Newsfeed",
  "Conferences and Events": "Conferences and Events",
  "Messaging": "Messaging",
  "Program": "Program",
  "Donations": "Donations",
  "Files": "Files",
  "Daily Digest (Evening)": "Daily Digest (Evening)",
  "Daily Digest (Morning)": "Daily Digest (Morning)",
  "Hero Image": "Hero Image",
  "Organization": "Organization",
  "Email Notifications": "Email Notifications",
  "Push Notifications": "Push Notifications",
  "Community Member Permissions": "Community Member Permissions",
  "Enable Posts, Comments and Replies": "Enable Posts, Comments and Replies",
  "Disable Posts, Comments and Replies": "Disable Posts, Comments and Replies",
  "Privacy": "Privacy",
  "Public": "Public",
  "Private": "Private",
  "Secret": "Secret",
  "Default community always needs to be public.": "Default community always needs to be public.",
  "Default community always needs to be secret.": "Default community always needs to be secret.",
  "Update": "Update",
  "Member": "Member",
  "Joined!": "Joined!",
  "Start Exploring!": "Start Exploring!",
  "Join Now!": "Join Now!",
  "Request sent": "Request sent",
  "Requests to join communities are generally reviewed within <1>24 hours</1>. Feel free to continue browsing other communities that interest you.": "Requests to join communities are generally reviewed within <1>24 hours</1>. Feel free to continue browsing other communities that interest you.",
  "Request to Join": "Request to Join",
  "Why do you want to join this community?": "Why do you want to join this community?",
  "Send": "Send",
  "Archive": "Archive",
  "Duplicate": "Duplicate",
  "Free Program": "Free Program",
  "authorWeeks": "By {{name}} • {{weeks}} weeks",
  "Sponsored by": "Sponsored by",
  "Learn more": "Learn more",
  "Let us know why you want to join this community": "Let us know why you want to join this community",
  "registered": "registered",
  "Unsubscribe": "Unsubscribe",
  "Subscribe": "Subscribe",
  "Are you sure you want to duplicate this program?": "Are you sure you want to duplicate this program?",
  "Program successfully duplicated.": "Program successfully duplicated.",
  "Duplicate program": "Duplicate program",
  "Please choose date in the future": "Please choose a date in the future",
  "Start date": "Start date",
  "Duplicate with users": "Duplicate with users",
  "Duplicate without users": "Duplicate without users",
  "Price must be higher than sponsors prices": "Price must be higher than sponsor(s) price(s)",
  "Program name": "Program name",
  "Choose...": "Choose...",
  "Author/Provider": "Author/Provider",
  "Author/Provider Content": "Author/Provider Content",
  "Content": "Content",
  "Program description": "Program description",
  "Who should enroll": "Who should enroll",
  "Instructors": "Instructors",
  "Save as Draft": "Save as Draft",
  "Category": "Category",
  "Logo": "Logo",
  "Starts": "Starts",
  "Ends": "Ends",
  "Price": "Price",
  "Free program": "Free program",
  "Modules": "Modules",
  "Comment in Program": "Allow comments",
  "Enable Comments": "Enable Comments",
  "Disable Comments": "Disable Comments",
  "A request for approval will be created. The change will not be immediate.": "A request for approval will be sent. The change will not be immediate.",
  "Member is automatically enrolled": "Member is automatically enrolled",
  "Mandatory enrollment is automatically turned on because program is set as Featured for this WLA. To change this go to Admin Console.": "Mandatory enrollment is automatically turned on because program is set as Featured for this WLA. To change this go to Admin Console.",
  "Go to Admin Console": "Go to Admin Console",
  "Expected outcomes": "Expected outcomes",
  "Featured participant": "Featured participant",
  "Featured participant quote": "Quote from featured participant",
  "Photo": "Photo",
  "Add featured participant": "Add featured participant",
  "Sponsor name": "Sponsor name",
  "Sponsor": "Sponsor",
  "Add sponsor": "Add sponsor",
  "Module": "Module",
  "Module Description": "Module Description",
  "+ Add Module": "+ Add Module",
  "Back": "Back",
  "Create New": "Create New",
  "Search Organization": "Search Organization",
  "Search Community": "Search Community",
  "Invitations have been sent.": "Invitations have been sent.",
  "Invite Organizations": "Invite Organizations",
  "Invite Communities": "Invite Communities",
  "Posts": "Posts",
  "Events": "Events",
  "Polls": "Polls",
  "Activities": "Activities",
  "Default": "Default",
  "Sort By": "Sort By",
  "Date created": "Date created",
  "Alphabetically": "Alphabetically",
  "Content type": "Content type",
  "Filter by category": "Filter by category",
  "Select": "Select",
  "No content yet": "No content yet",
  "Posted by": "Posted by",
  "Hosted by": "Hosted by",
  "Posted": "Posted",
  "Please select the module the post belongs to": "Please select the module the post belongs to",
  "Formik is not valid": "Form is not valid",
  "Continue reading": "Continue reading",
  "What is on your mind": "What is on your mind",
  "Count not process your request. Please try again later.": "We could not process your request. Please try again later.",
  "Today": "Today",
  "Yesterday": "Yesterday",
  "Custom": "Custom",
  "Clear": "Clear",
  "Please check your form": "Please check your form",
  "Do you wish to discard your Event?": "Do you wish to discard your Event?",
  "Live": "Live",
  "Join": "Join",
  "Test": "Test",
  "Excel": "Excel",
  "PDF": "PDF",
  "Make a Donation": "Make a Donation",
  "Finished": "Finished",
  "Kudos to": "Kudos to",
  "votes": "votes",
  "Do you really want to delete this event and all its content?": "Do you really want to delete this event and all its content?",
  "Delete this Post/Comment?": "Delete this Post/Comment?",
  "Report this Post/Event/Comment?": "Report this Post/Event/Comment?",
  "events": "events",
  "see all": "see all",
  "File cannot be downloaded, please try again later.": "File cannot be downloaded, please try again later.",
  "Downloading": "Downloading",
  "Something went wrong. Please, try again later.": "Something went wrong. Please, try again later.",
  "Enter Your E-mail": "Enter Your E-mail",
  "Request new Password": "Request new Password",
  "Administrators": "Administrators",
  "Invite": "Invite",
  "Please click X and scroll down and submit the form to reflect the changes in the \"\" section": "Please click X and scroll down and submit the form to reflect the changes in the \"\" section",
  "You cannot remove the last user!": "You cannot remove the last user!",
  "You cannot remove yourself!": "You cannot remove yourself!",
  "No": "No",
  "Post in...": "Post in...",
  "Search...": "Search...",
  "Hide": "Hide",
  "Show": "Show",
  "KB": "KB",
  "more": "more",
  "Conversations": "Conversations",
  "Communities": "Communities",
  "Organizations": "Organizations",
  "Programs": "Programs",
  "People": "People",
  "Joined": "Joined",
  "Not Joined": "Not Joined",
  "No results found": "No results found",
  "See all": "See all",
  "Done": "Done",
  "Choose member": "Choose member",
  "Expressing Kudos to": "Expressing Kudos to",
  "Password": "Password",
  "Incorrect username and password.": "Incorrect username and password.",
  "Could not log in at this time. Please, try again later.": "Could not log in at this time. Please, try again later.",
  "Log In": "Log In",
  "Forgot password?": "Forgot password?",
  "Message": "Message",
  "About me": "About me",
  "Works at:": "Works at:",
  "Joined Organizations": "Joined Organizations",
  "Joined Communities": "Joined Communities",
  "Call": "Call",
  "Change role": "Change role",
  "Remove": "Remove",
  "Type a name...": "Type a name...",
  "No results": "No results",
  "Type a message...": "Type a message...",
  "Search members...": "Search members...",
  "This is very beginning of your conversation": "This is very beginning of your conversation",
  "No conversations yet.": "No conversations yet.",
  "No member found.": "No member found.",
  "Maximum size per attached file is": "Maximum size per attached file is",
  "Please try it again.": "Please try it again.",
  "Enter New Password": "Enter New Password",
  "Confirm New Password": "Confirm New Password",
  "Provided password reset token is invalid.": "Provided password reset token is invalid.",
  "Updating...": "Updating...",
  "Badge Notifications": "Badge Notifications",
  "You are about to delete this organization. By deleting this organization, you will also delete all of the organization's associated communities. Are you sure you want to delete this organization?": "You are about to delete this organization. By deleting this organization, you will also delete all of the organization's associated communities. Are you sure you want to delete this organization?",
  "Are you sure you want to delete this organization? If you continue, all communities related to the organization will be permanently deleted. No content or communities related to the organization can be recovered.": "Are you sure you want to delete this organization? If you continue, all communities related to the organization will be permanently deleted. No content or communities related to the organization can be recovered.",
  "The field is required in the following URL format: https://www.example.com": "The field is required in the following URL format: https://www.example.com",
  "This field must be at least 9.": "This field must contain 9 digits.",
  "Organization URL": "Organization URL",
  "EIN Number": "EIN Number",
  "Please select a state": "Please select a state",
  "Inverse Logo": "Inverse Logo",
  "About": "About",
  "No communities": "No communities",
  "More filters": "More filters",
  "Filter by Organization and Community": "Filter by Organization and Community",
  "Your Computer": "Your Computer",
  "Dropbox": "Dropbox",
  "Dropbox SDK failed to load": "Dropbox SDK failed to load",
  "Dropbox is not loaded": "Dropbox is not loaded",
  "Poll question": "Poll question",
  "Choice": "Choice",
  "Add Poll": "Add Poll",
  "Remove poll": "Remove poll",
  "Express your Kudos...": "Express your Kudos...",
  "Post": "Post",
  "Pin post": "Pin post",
  "Post pinned": "Post pinned",
  "What is on your mind, ": "What is on your mind, ",
  "Search by user name or email...": "Search by user name or email...",
  "Network": "Network",
  "Other networks": "Other networks",
  "The post has been successfully shared": "The post has been successfully shared",
  "Sharing Post": "Sharing Post",
  "Insert comment...": "Insert comment...",
  "Share on:": "Share on:",
  "email has already been taken.": "E-mail has already been taken.",
  "Could not sign up at this time. Please, try again later.": "Could not sign up at this time. Please, try again later.",
  "Sign Up": "Sign Up",
  "Sign up": "Sign up",
  "Hide Translation": "Hide Translation",
  "See Translation": "See Translation",
  "Undo": "Undo",
  "Members": "Members",
  "White label": "White label",
  "Your Profile": "Your Profile",
  "Settings": "Settings",
  "Help": "Help",
  "Invite Friends": "Invite Friends",
  "Log out": "Log out",
  "Home": "Home",
  "Messages": "Messages",
  "Dashboard": "Dashboard",
  "Go Back": "Go Back",
  "News": "News",
  "Leave Community": "Leave Community",
  "Are you sure you want to leave <strong>{{communityName}}</strong> community?": "Are you sure you want to leave <strong>{{communityName}}</strong> community?",
  "Failed to leave community.": "Failed to leave community.",
  "English": "English",
  "Are you sure you want to report this program?": "Are you sure you want to report this program?",
  "Are you sure you want to leave this program?": "Are you sure you want to leave this program?",
  "Unsubscribe program": "Unsubscribe program",
  "Are you sure you want to unsubscribe <strong>{{programName}}</strong> program?": "Are you sure you want to unsubscribe <strong>{{programName}}</strong> program?",
  "You've successfully left the program": "You've successfully left the program",
  "You have joined the program.": "You have joined the program.",
  "Timeline/Newsfeed": "Content",
  "Edit Event": "Edit Event",
  "Delete Event": "Delete Event",
  "Report Event": "Report Event",
  "Finish": "Finish",
  "Create": "Create",
  "Title": "Title",
  "Search community": "Search community",
  "Apt": "Apt",
  "From": "From",
  "To": "To",
  "Allow custom amount": "Allow custom amount",
  "Successfully saved!": "Successfully saved!",
  "Something went wrong.": "Something went wrong.",
  "member(s)": "member(s)",
  "No Communities": "No Communities",
  "Create New Community": "Create New Community",
  "Community was successfully updated.": "Community was successfully updated.",
  "Community was successfully created.": "Community was successfully created.",
  "Community successfully deleted.": "Community successfully deleted.",
  "Cannot delete this community right now, please try again later.": "Cannot delete this community right now, please try again later.",
  "It can take several minutes to delete large community. Please wait.": "It can take several minutes to delete a large community. Please wait.",
  "Summary": "Summary",
  "Report was successfully sent.": "Report was successfully sent.",
  "Send donation receipts": "Send donation receipts",
  "Donors": "Donors",
  "donors selected": "donors selected",
  "Pin Posts": "Pin Posts",
  "Upload Files": "Upload Files",
  "Email format is invalid. Correct format is name@domain.tld.": "Email format is invalid. Correct format is name@domain.tld.",
  "Search users...": "Search users...",
  "Pending Requests": "Pending Requests",
  "See more requests": "See more requests",
  "There are no more requests to be loaded": "There are no more requests to be loaded",
  "Successfully invited!": "Successfully invited!",
  "Type email address and press enter, space or comma - Or copy/paste from a spreadsheet!": "Type email address and press enter, space or comma - Or copy/paste from a spreadsheet!",
  "Inviting...": "Inviting...",
  "Currently there are no pending requests": "Currently there are no pending requests",
  "Accept": "Accept",
  "Decline": "Decline",
  "requested to join": "requested to join",
  "reason to join": "reason to join",
  "No organizations": "No organizations",
  "Create New Organization": "Create New Organization",
  "Unlink": "Unlink",
  "BigMarker event is not ready yet. Try again later.": "The event is not ready yet. Try again later.",
  "BACK": "BACK",
  "Started in": "Started in",
  "Check donations": "Check donations",
  "No Results": "No Results",
  "group": "group",
  "Contact": "Contact",
  "Join Community": "Join Community",
  "Folder Successfully Created.": "Folder Successfully Created.",
  "Cannot create folder.": "Cannot create folder.",
  "Upload Successful.": "Upload Successful.",
  "Add File": "Add File",
  "Next": "Next",
  "Browse Organizations": "Browse Organizations",
  "to Get Started": "to Get Started",
  "Upcoming": "Upcoming",
  "Past": "Past",
  "+ Create": "+ Create",
  "EVENTS": "EVENTS",
  "These users": "These users",
  "This user": "This user",
  "are already on the app.": "are already on the app.",
  "is already on the app.": "is already on the app.",
  "Email addresses...": "Email addresses...",
  "Notification settings was successfully updated.": "Notification settings were successfully updated.",
  "Community Notification Settings": "Community Notification Settings",
  "No Description": "No Description",
  "Learn More": "Learn More",
  "By": "By",
  "Who should enroll in this program?": "Who should enroll in this program?",
  "Featured Participants": "Featured Participants",
  "Overview": "Overview",
  "All Folders": "All Folders",
  "No programs": "No programs",
  "All programs": "All programs",
  "My programs": "My programs",
  "Draft": "Draft",
  "Published": "Published",
  "Archived": "Archived",
  "Not joined yet.": "Not joined yet.",
  "Date Enrolled": "Date Enrolled",
  "Date Invited": "Date Invited",
  "Enroll Members": "Enroll Members",
  "+ Enroll Members": "+ Enroll Members",
  "Sort by:": "Sort by:",
  "Pending": "Pending",
  "You are at the end of the list. There are no more users to be loaded.": "You are at the end of the list. There are no more users to load.",
  "All Objects": "All Objects",
  "Add New Post": "Add New Post",
  "+ Add New Post": "+ Add New Post",
  "+ Add New Event": "+ Add New Event",
  "End of program content.": "End of program content.",
  "Select some post": "Select a post",
  "My Programs": "My Programs",
  "Explore BigHeart Network Programs": "Explore BigHeart Network Programs",
  "Explore the programs you are not a member of": "Explore the programs you are not a member of",
  "Please select a program you want to go to": "Please select a program you want to go to",
  "Explore more programs": "Explore more programs",
  "What type of program are you looking for?": "What type of program are you looking for?",
  "Select category to get started": "Select category to get started",
  "No invitees found with these parameters.": "No invitees found with these parameters.",
  "Are you sure you want to delete this event?": "Are you sure you want to delete this event?",
  "All Invitees": "All Invitees",
  "Registered": "Registered",
  "Admin/Host": "Admin/Host",
  "Event successfully deleted.": "Event successfully deleted.",
  "Event was not deleted, please try again later.": "Event was not deleted, please try again later.",
  "It can take several seconds to delete an event. Please wait.": "It can take several seconds to delete an event. Please wait.",
  "Filter:": "Filter:",
  "PLAY RECORDING": "PLAY RECORDING",
  "No recording available": "No recording available",
  "Video is processing...": "Video is processing...",
  "Not able to join this video conference": "Not able to join this video conference",
  "Dial-In Information": "Dial-In Information",
  "Phone Number": "Phone Number",
  "Dial-in ID": "Dial-in ID",
  "Dial-in Passcode": "Dial-in Passcode",
  "Are you going?": "Are you going?",
  "Comments": "Comments",
  "Video recording": "Video recording",
  "Your browser does not support the video tag.": "Your browser does not support the video tag.",
  "Event Post Create": "Event Post Create",
  "Results for": "Results for",
  "General inquiries": "General inquiries",
  "Cancel Payment": "Cancel Payment",
  "To cancel or change your recurring donation, please email us at:": "To cancel or change your recurring donation, please email us at:",
  "SEND INVITATIONS": "SEND INVITATIONS",
  "Invite to:": "Invite to:",
  "Sign Up Using Email": "Sign Up Using Email",
  "or using social login": "or using social login",
  "Already have an account?": "Already have an account?",
  "Log in": "Log in",
  "Find Organizations": "Find Organizations",
  "No Organizations": "No Organizations",
  "My Communities": "My Communities",
  "Explore BigHeart Network Communities": "Explore BigHeart Network Communities",
  "Explore the communities you are not a member of": "Explore the communities you are not a member of",
  "What type of nonprofit are you looking for?": "What type of nonprofit are you looking for?",
  "Please select a community you want to go to": "Please select a community you want to go to",
  "Explore more communities": "Explore more communities",
  "New Password": "New Password",
  "Your Notifications": "Your Notifications",
  "Organization was successfully created.": "Organization was successfully created.",
  "Create a Default Community": "Create a Default Community",
  "Name:": "Name:",
  "City:": "City:",
  "Address:": "Address:",
  "State:": "State:",
  "Organization was successfully updated.": "Organization was successfully updated.",
  "Organization successfully deleted.": "Organization successfully deleted.",
  "Cannot delete this organization right now, please try again later.": "Cannot delete this organization right now, please try again later.",
  "It can take several minutes to delete large organization. Please wait.": "It can take several minutes to delete large organization. Please wait.",
  "Join Now": "Join Now",
  "Join an organization": "Join an organization",
  "that interests you": "that interests you",
  "Personal Information": "Personal Information",
  "Do you really want to leave this community?": "Do you really want to leave this community?",
  "Leave community": "Leave community",
  "Notifications": "Notifications",
  "Translations": "Translations",
  "Translation settings was successfully updated.": "Translation settings was successfully updated.",
  "Please, select language": "Please, select language",
  "Enable Translations": "Enable Translations",
  "Language": "Language",
  "Not allowed to see this": "Not allowed to see this",
  "This event has started already": "This event has started already",
  "This video conference is already over": "This video conference is already over",
  "No events": "No events",
  "ago": "ago",
  "You have no unread notifications.": "You have no unread notifications.",
  "Mark all as read": "Mark all as read",
  "Notifications Settings": "Notifications Settings",
  "Video Conference": "Video Conference",
  "Up to 64 participants total": "Up to 64 participants total",
  "Interactive mode: all can share camera and audio": "Interactive mode: all can share camera and audio",
  "Up to 64 admins/presenters with 1000 participants total": "Up to 64 admins/presenters with 1000 participants total",
  "Presentation mode: Attendees can view, hear, chat, etc.": "Presentation mode: Attendees can view, hear, chat, etc.",
  "Interactive mode for members of Medical Communities": "Interactive mode for members of Medical Communities",
  "Webinar/Webcast": "Webinar/Webcast",
  "Please provide at least one community": "Please provide at least one community",
  "By e-mail": "By e-mail",
  "search...": "search...",
  "No matches.": "No matches.",
  "Failed to upload": "Failed to upload",
  "Please wait for image upload": "Please wait for the image to upload",
  "Add Featured Participant": "Add Featured Participant",
  "Please provide start date": "Please provide start date",
  "Please provide end date": "Please provide end date",
  "Add Module": "Add Module",
  "Add Outcome": "Add Outcome",
  "Add Sponsor": "Add Sponsor",
  "No selected users.": "No selected users.",
  "Orange": "Orange",
  "Blue": "Blue",
  "Green": "Green",
  "Red": "Red",
  "Gray": "Gray",
  "Black": "Black",
  "byEmail": "By e-mail {{number}}",
  "registeredUsers": "Registered: {{number}}",
  "startTimeError": "Start date and time of program must be set in the future",
  "endTimeError": "End date and time of program must be set at least 60 minutes ahead of start date and time",
  "modulesError": "Program modules can't be blank",
  "priceError": "Program price must be greater than or equal to sum of sponsored prices",
  "Program was created.": "Program was created.",
  "Failed to create program.": "Failed to create program.",
  "Admin": "Admin",
  "Author": "Author",
  "Invite admins / hosts": "Invite admins / hosts",
  "Invite presenters": "Invite presenters",
  "Invite attendees": "Invite attendees",
  "Edit Webinar / Webcast": "Edit Webinar / Webcast",
  "Edit Video Conference": "Edit Video Conference",
  "Create Webinar / Webcast": "Create Webinar / Webcast",
  "Create Video Conference": "Create Video Conference",
  "Please select the module the event belongs to": "Please select the module the event belongs to",
  "Event details": "Event details",
  "Starts on": "Starts on",
  "For": "For",
  "Select community to invite": "Select community to invite",
  "Select community": "Select community",
  "Who do you want to invite?": "Who do you want to invite?",
  "All community members": "All community members",
  "You will invite all community members.": "You will invite all community members.",
  "Select community members": "Select community members",
  "Only invited community members can join.": "Only invited community members can join.",
  "Attendees": "Attendees",
  "Admins / Hosts": "Admins / Hosts",
  "Presenters": "Presenters",
  "Additional details": "Additional details",
  "Event photo": "Event photo",
  "Slides": "Slides",
  "hours": "hours",
  "hour": "hour",
  "minute": "minute",
  "minutes": "minutes",
  "Action cancelled": "Action cancelled",
  "Featured participant name": "Featured participant name",
  "Upload featured participant photo": "Upload featured participant photo",
  "Basic information": "Basic information",
  "Select organization": "Select organization",
  "Categories": "Categories",
  "Select category": "Select category",
  "Author / Provider": "Author / Provider",
  "Upload author logo": "Upload author logo",
  "Author / Provider content": "Author / Provider content",
  "Dates and price": "Dates and price",
  "Start date and time": "Start date and time",
  "End date and time": "End date and time",
  "Who should enroll in and outcomes": "Who should enroll in this program and program outcomes",
  "Instructors, administrators and featured participants": "Instructors, administrators and featured participants",
  "Invite administrators": "Invite administrators",
  "Add administrator": "Add administrator",
  "Invite instructors": "Invite instructors",
  "Add instructor": "Add instructor",
  "Allow comments": "Allow comments",
  "Expected outcome": "Expected outcome",
  "Sponsored price": "Sponsored price",
  "Special characters": "Special characters",
  "Characters": "Characters",
  "Poll was created.": "Poll was created.",
  "Failed to create poll.": "Failed to create poll.",
  "Create Poll": "Create Poll",
  "Delete poll": "Delete poll",
  "Create poll": "Create poll",
  "Create kudo": "Create kudo",
  "Please select the module the poll belongs to": "Please select the module the poll belongs to",
  "Select type": "Select type",
  "Multiple choice": "Multiple choice",
  "Option": "Option",
  "Poll": "Poll",
  "You can’t Give Kudos now": "You can’t Give Kudos now",
  "pollVotes_one": "vote",
  "pollVotes_other": "votes",
  "Failed to add vote": "Failed to add vote",
  "Activity was created.": "Activity was created.",
  "Failed to create activity.": "Failed to create activity.",
  "Add New Activity": "Add New Activity",
  "Activity was updated.": "Activity was updated.",
  "Failed to update activity.": "Failed to update activity.",
  "Edit Activity": "Edit Activity",
  "Please select the module the activity belongs to": "Please select the module the activity belongs to",
  "Activity name": "Activity name",
  "Activity Description": "Activity Description",
  "Please make your selection": "Please make your selection",
  "Please, select maximum 3 interests": "Please, select a maximum of 3 interests",
  "Please, select gender": "Please, select gender",
  "Education level": "Education level",
  "Please, select education level": "Please, select an education level",
  "Apartment": "Apartment",
  "Profession": "Profession",
  "Please, select profession": "Please, select a profession",
  "Company name/school": "Company name/school",
  "Biography": "Biography",
  "Edit Poll": "Edit Poll",
  "Poll was updated.": "Poll was updated.",
  "Failed to update poll.": "Failed to update poll.",
  "Create content": "Create content",
  "What type of content do you want to create?": "What type of content do you want to create?",
  "Create Post": "Create Post",
  "Create Event": "Create Event",
  "Create Activity": "Create Activity",
  "Poll has ended": "Poll has ended",
  "End time was changed to 1 hour later according to start time": "End time was changed to 1 hour later compared to start time",
  "Poll not started yet": "Poll not started yet",
  "You can’t create Poll now": "You can’t create a Poll right now",
  "brandedCommunities": "Explore {{brandedName}} Communities",
  "Your progress was recorded.": "Your response was recorded.",
  "Thank you for new recording!": "Thank you.",
  "Failed to record your progress.": "Failed to record your response.",
  "Do you wish to discard your Poll?": "Do you wish to discard your Poll?",
  "Activity did not start": "Activity did not start.",
  "Activity has ended": "Activity has ended.",
  "Download report": "Download report",
  "activityPeriod": "You will be able to record your response on {{day}}.",
  "postedBy": "Posted on {{ createdAt, shortMonthDayYear }} at {{ createdAt, time }} by:",
  "publishedBy": "Published on {{ publishedAt, shortMonthDayYear }} at {{ publishedAt, time }} by:",
  "Was this valuable?": "Was this valuable?",
  "Your evaluation was recorded.": "Your evaluation was recorded.",
  "Failed to record your evaluation.": "Failed to record your evaluation.",
  "Create post...": "Create post...",
  "notValidPhone": "{{phoneNumber}} is not valid phone number. The number must start with area code + and must not contain any spaces. Example: +12133734253",
  "Please select periodicity": "Please select frequency",
  "Daily": "Daily",
  "Weekly": "Weekly",
  "Monday": "Monday",
  "Tuesday": "Tuesday",
  "Wednesday": "Wednesday",
  "Thursday": "Thursday",
  "Friday": "Friday",
  "Saturday": "Saturday",
  "Sunday": "Sunday",
  "I agree with": "I agree with",
  "and": "and",
  "Upload sponsor logo": "Upload sponsor logo",
  "Spanish": "Spanish",
  "Number": "Number",
  "Text": "Text",
  "or": "or",
  "Select language": "Select language",
  "Report was successfully downloaded.": "Report was successfully downloaded.",
  "Failed to download report.": "Failed to download report.",
  "You are not authorized to perform this action.": "You are not authorized to perform this action.",
  "Frequency": "Frequency",
  "Question": "Question",
  "Please, select a community.": "Please, select a community.",
  "Ends on": "Ends on",
  "This field is required.": "This field is required.",
  "Do you wish to log out?": "Do you wish to log out?",
  "Profile has been successfully updated.": "Profile has been successfully updated.",
  "Cannot update your profile right now, please try again later.": "Cannot update your profile right now, please try again later.",
  "Your account is locked for 30 minutes after 5 failed attempts to login.": "Your account has been locked for 30 minutes after 5 failed attempts to login.",
  "Your password expired. Please set a new password.": "Your password expired. Please set a new password.",
  "password was used previously.": "Password was used previously.",
  "passwordError": "Password must contain minimum 12 characters, maximum 72 characters, at least one uppercase letter, one lowercase letter, one number, one special character and different than your last 10 passwords",
  "passwordErrorUsed": "Your new password must be different than your last 10 passwords",
  "passwordErrorCurrentPasswordInvalid": "Current password is invalid",
  "Reminders": "Reminders",
  "Add new reminder": "Add new reminder",
  "Add new time": "Add new time",
  "Submit your values": "Submit your response",
  "Are you sure you want to submit your response?": "Are you sure you want to submit your response?",
  "Time": "Time",
  "activityNotAvailableToday": "You will be able to record your response on {{day}} at {{time}}.",
  "activityAvailableAtAnotherTime": "You will be able to record your response later today at {{time}}.",
  "current_password is invalid": "Current password is invalid",
  "No reminders were created for this activity": "No reminders were created for this activity",
  "reset_password_token is invalid": "Reset password token is invalid",
  "Do you wish to discard your Activity?": "Do you wish to discard your Activity?",
  "Your account is locked.": "Your account is locked.",
  "Bookmarks": "Bookmarks",
  "Comment": "Comment",
  "Unbookmark": "Unbookmark",
  "Successfully unbookmarked": "Successfully unbookmarked",
  "Something went wrong. The item couldn't be unbookmarked.": "Something went wrong. The item couldn't be unbookmarked.",
  "view comment": "view comment",
  "view post": "view post",
  "view poll": "view poll",
  "view event": "view event",
  "view activity": "view activity",
  "Withings Sync": "Withings Sync",
  "Link with my Withings Account": "Link with my Withings Account",
  "Unlink my Withings Account": "Unlink my Withings Account",
  "Program module": "Program module",
  "Webinar / Webcast name": "Webinar / Webcast name",
  "Video conference name": "Video conference name",
  "Invitations": "Invitations",
  "Poll details": "Poll details",
  "Poll content": "Poll content",
  "Add new question": "Add new question",
  "Add option": "Add option",
  "Label": "Label",
  "Answers": "Answers",
  "Answer...": "Answer...",
  "Do you wish to discard your Post?": "Do you wish to discard your Post?",
  "Post content": "Post content",
  "Post details": "Post details",
  "Post was created.": "Post was created.",
  "Failed to create post.": "Failed to create post.",
  "Post was updated.": "Post was updated.",
  "Failed to edit post.": "Failed to edit post.",
  "Single choice": "Single choice",
  "Continue": "Continue",
  "Activity details": "Activity details",
  "(e.g.: select which exercise you did and for how long)": "(e.g.: Select activity and duration)",
  "Data will be transferred automatically from Withings": "Data will be transferred automatically from Withings",
  "What?": "What?",
  "What is expected? (e.g.: personal feedback to the webinar)": "What information are you requesting from the user? (e.g.: personal feedback to the webinar)",
  "What is expected? (e.g.: your blood sugar value)": "What is expected? (e.g.: your blood sugar value)",
  "What is expected? (e.g.:select the activity you did today)": "What information are you requesting from the user? (e.g.:select the activity you did today)",
  "Unit": "Unit",
  "List of options (divide items by commas)": "List activities” (separate activities with commas)",
  "Define options... (e.g..: run, walk, bike, jogging)": "Define options... (e.g..: run, walk, bike, jogging)",
  "List of units (divide items by commas)": "“List units”  (separate units with commas)",
  "Define units... (e.g.: minutes, lbs, miles)": "Define units... (e.g.: minutes, lbs, miles)",
  "Finish & Publish": "Finish & Publish",
  "Numeric value": "Numeric value",
  "Select type of activity": "Select type of activity",
  "Describe the question or response.": "Describe the question or response.",
  "Type of response data": "Type of response data",
  "Manual": "Manual",
  "Withings weight": "Withings weight",
  "Withings duration": "Withings duration",
  "Withings distance": "Withings distance",
  "White board": "White board",
  "Attach file": "Attach file",
  "Kudos": "Kudos",
  "BigHeart Inputs": "BigHeart Inputs",
  "T4IT Inputs": "T4IT Inputs",
  "Please select all that apply": "Please select all that apply",
  "Please select one": "Please select one",
  "Thank you for your feedback.": "Thank you for your feedback.",
  "Failed to send feedback.": "Failed to send feedback.",
  "Journal": "Journal",
  "Create note": "Create note",
  "Do you wish to discard your Note?": "Do you wish to discard your Note?",
  "Delete this journal entry?": "Delete this journal entry?",
  "Please select option": "Please select option",
  "Is this Visit for you?": "Is this visit for you?",
  "Visitor information": "Visitor information",
  "Do you wish to discard your changes?": "Do you wish to discard your changes?",
  "Your donation was not successful": "Your donation was not successful",
  "Validation failed: Start time must be in the future": "Validation failed: Start time must be in the future",
  "Authored by": "Authored by",
  "Enter program": "Enter program",
  "Search Member": "Search Member",
  "You are not currently enrolled in a program. Click “Explore” to browse programs.": "You are not currently enrolled in a program. Click “Explore” to browse programs.",
  "Admins": "Admins",
  "Your video conference has ended. Click on the button below to go back to the app.": "Your video conference has ended. Click on the button below to go back to the app.",
  "Back to app": "Back to app",
  "Please synchronize the withings device with your mobile app today.": "Please synchronize the withings device with your mobile app today.",
  "You currently don't have any bookmarked content": "You currently don't have any bookmarked content",
  "invitationStatus": "{{ status }} {{ date, shortMonthDayYear }} at {{ date, time }}",
  "fileSearchItemDate": "{{ date, shortMonthDayYear }}{{ fileName }}",
  "postSearchItemDate": "{{ date, shortMonthDayYear }} in {{ community }}",
  "Access token is expired or invalid.": "Access token is expired or invalid.",
  "User must be a member of a community with valid MOD invitation code": "User must be a member of a community with valid MOD invitation code",
  "Password complexity insufficient": "Password complexity insufficient",
  "This account is no longer valid. Please sign up with a new account.": "This account is no longer valid. Please sign up with a new account.",
  "donationMinimum": "The minimum value is US ${{min}}",
  "Admin console": "Admin console",
  "Pinned posts": "Pinned posts",
  "Modules with attached content can't be removed": "Modules with attached content can't be removed",
  "multiFieldInviteError_one": "This user {{items}} is already on the app - please invite them via the registered user option above.",
  "multiFieldInviteError_other": "These users {{items}} are already on the app - please invite them via the registered user option above.",
  "This community has no content.": "This community has no content.",
  "Activity task has been filled in already": "Activity task has been filled in already",
  "Search user or content...": "Search user or content...",
  "Add another activity": "Add another activity",
  "Activity": "Activity",
  "Send reset link": "Send reset link",
  "Your password was successfully changed": "Your password was successfully changed",
  "Terms": "Terms",
  "Privacy Policy": "Privacy Policy",
  "Back to Log in": "Back to Log in",
  "resetRequestSuccess": "Link was successfully sent to your email. Please, open the link we sent you and reset your password.",
  "Remember me": "Remember me",
  "Submit activity": "Submit activity",
  "withingsInfoMessage": "Allow registered user to fill Withings order form and BE will assign the AEN of Withings devices. Withings devices can be ordered automatically in program",
  "Imperial": "Imperial",
  "Metric": "Metric",
  "shareEmailInfoMessage": "You should have an e-mail client installed on your device supporting this feature.",
  "Male": "Male",
  "Female": "Female",
  "Height": "Height",
  "Gender": "Gender",
  "Date of birth": "Date of birth",
  "Weight": "Weight",
  "Delivery information": "Delivery information",
  "Telephone number": "Telephone number",
  "Address 1 (Street with number)": "Address 1 (Street with number)",
  "Street with number": "Street with number",
  "Address 2 (Apartment or suite number)": "Address 2 (Apartment or suite number)",
  "Apartment or suite number": "Apartment or suite number",
  "Zip code": "Zip code",
  "Device preset": "Device preset",
  "Personal information": "Personal information",
  "Phone number": "Phone number",
  "Address": "Address",
  "I agree to receive commercial and marketing emails from Withings": "I agree to receive commercial and marketing emails from Withings",
  "Subscribe with order": "Subscribe with order",
  "Continue to program": "Continue to program",
  "Reset password": "Reset password",
  "The devices will be delivered to your delivery address within two weeks. In the next steps it is necessary to enter your personal data, confirm the delivery address. The devices will be customized for you.": "The devices will be delivered to your delivery address within two weeks. In the next steps it is necessary to enter your personal data, confirm the delivery address. The devices will be customized for you.",
  "Order request": "Order request",
  "My language": "My language",
  "My timezone": "My timezone",
  "Order was successful!": "Order was successful!",
  "Copy invite to clipboard": "Copy invite to clipboard",
  "Create Withings order": "Create Withings order",
  "Do you wish to discard your Order?": "Do you wish to discard your Order?",
  "Select module": "Select module",
  "Withings order": "Withings order",
  "Create order": "Create order",
  "Edit Order": "Edit Order",
  "Edit Post": "Edit Post",
  "Create Order": "Create Order",
  "Withings order has been filled in already": "Withings order has been filled in already",
  "recurringPaymentInfo": "You will be charged every {{interval}} from this day forward until canceled.",
  "cancelRecurringPaymentInfo": "To cancel or change your recurring gift, please go to your profile.",
  "RPM program": "RPM program",
  "DPP program": "DPP program",
  "Move Activity Tracker Watch + Body Pro Scale": "Move Activity Tracker Watch + Body Pro Scale",
  "Price options": "Price options",
  "Paid": "Paid",
  "Free": "Free",
  "Contact us": "Contact us",
  "Send Request": "Send Request",
  "Write your answer...": "Write your answer...",
  "Why do you want to subscribe?": "Why do you want to subscribe?",
  "Request to Subscribe": "Request to Subscribe",
  "requestToJoinFormTextAreaLabel": "Text",
  "Withings calories": "Withings calories",
  "Withings steps": "Withings steps",
  "Community cover image": "Community cover image",
  "membersCount_one": "{{count}} member",
  "membersCount_other": "{{count}} members",
  "Leave": "Leave",
  "Leave community?": "Leave community?",
  "Do you want to leave selected community?": "Do you want to leave selected community?",
  "Daily Digest (Evening time)": "Daily Digest (Evening time)",
  "Daily Digest (Morning time)": "Daily Digest (Morning time)",
  "Save": "Save",
  "Crop your image": "Crop your image",
  "Sorry, resource does not exist.": "Sorry, resource does not exist.",
  "Sorry, something went wrong.": "Sorry, something went wrong.",
  "Sorry, you are not authorized to access this resource.": "Sorry, you are not authorized to access this resource.",
  "Please check your internet connection.": "Please check your internet connection.",
  "Failed": "Failed",
  "Sending...": "Sending...",
  "Retry": "Retry",
  "Save {{fileName}}": "Save {{fileName}}",
  "Sorry, you are not authorized to perform this action.": "Sorry, you are not authorized to perform this action.",
  "Sorry, resource or target does not exist.": "Sorry, resource or target does not exist.",
  "My profile": "My profile",
  "Show more": "Show more",
  "Failed to load Overall Points.": "Failed to load Overall Points.",
  "Event name can't contain emojis": "Event name can't contain emojis",
  "Height (in)": "Height (in)",
  "Height (ft)": "Height (ft)",
  "You are not permitted to access this data.": "You are not permitted to access this data.",
  "Please take your blood pressure.": "Please take your blood pressure.",
  "Please take your weight.": "Please take your weight.",
  "Report this Kudo/Comment?": "Report this Kudo/Comment?",
  "Edit Cover Image": "Edit Cover Image",
  "Click to upload image or drag image into this area": "Click to upload image or drag image into this area",
  "Cover Image has to be {{width}}px width and {{height}}px height": "Cover Image has to be {{width}}px width and {{height}}px height",
  "{{fileName}} is not valid image": "{{fileName}} is not valid image",
  "File": "File",
  "Remove account": "Remove account",
  "Sign out": "Sign out",
  "Reason of your request": "Reason of your request",
  "Remove your account?": "Remove your account?",
  "Failed to remove account": "Failed to remove account",
  "Do you want to remove your account?": "Do you want to remove your account?",
  "Account removal request was sent. You will now be logged out from your account.": "Account removal request was sent. You will now be logged out from your account.",
  "Removing this account will delete all of its messages, contacts, and other data from the platform. This can’t be undone.": "Removing this account will delete all of its messages, contacts, and other data from the platform. This can’t be undone.",
  "You will be logged out from your account immediately after this action.": "You will be logged out from your account immediately after this action.",
  "Medical": "Medical",
  "Non-medical": "Non-medical",
  "No upcoming events": "No upcoming events",
  "No past events": "No past events",
  "Organization type": "Organization type",
  "Organization logo": "Organization logo",
  "Admin profile photo": "Admin profile photo",
  "Invite via phone number": "Invite via phone number",
  "Phone numbers": "Phone numbers",
  "E-mail addresses": "E-mail addresses",
  "Invite Non-registered Users": "Invite Non-registered Users",
  "Invite Registered Members": "Invite Registered Members",
  "Copy Invite Link": "Copy Invite Link",
  "Invite Selected": "Invite Selected",
  "Get shareable link to invite members": "Get shareable link to invite members",
  "Please, invite some users.": "Please, invite some users.",
  "Failed to invite users.": "Failed to invite users.",
  "Choose program": "Choose program",
  "Rejected": "Rejected",
  "File name": "File name",
  "Modified": "Modified",
  "Rename file": "Rename asset",
  "Asset name successfully changed": "Asset name successfully changed",
  "Asset successfully deleted": "Asset successfully deleted",
  "Delete file": "Delete file",
  "Delete folder": "Delete folder",
  "File deleted successfully": "File deleted successfully",
  "File renamed successfully": "File renamed successfully",
  "Folder deleted successfully": "Folder deleted successfully",
  "Folder renamed successfully": "Folder renamed successfully",
  "Are you sure you want to delete <strong>{{name}}</strong>?": "Are you sure you want to delete <strong>{{name}}</strong>?",
  "Folder <strong>{{name}}</strong> might not be empty. Are you sure you want to delete it?": "Folder <strong>{{name}}</strong> might not be empty. Are you sure you want to delete it?",
  "Something went wrong. File couldn't be deleted.": "Something went wrong. File couldn't be deleted.",
  "Something went wrong. File couldn't be renamed.": "Something went wrong. File couldn't be renamed.",
  "Something went wrong. Folder couldn't be deleted.": "Something went wrong. Folder couldn't be deleted.",
  "Something went wrong. Folder couldn't be renamed.": "Something went wrong. Folder couldn't be renamed.",
  "All Files": "All Files",
  "Upload": "Upload",
  "assetUploadSuccess": "{{asset}} successfully uploaded",
  "assetUploadFail": "Failed to upload {{asset}}",
  "Edit Description": "Edit Description",
  "Check donation": "Check donation",
  "Upcoming events": "Upcoming events",
  "No, I can't make it": "No, I can't make it",
  "Yes, I'm going": "Yes, I'm going",
  "Members ({{count}})": "Members ({{count}})",
  "Participants": "Participants",
  "eventLayoutDurationSameDate": "{{ dateFrom, shortMonthDayYear }} {{ dateFrom, time }} - {{ dateTo, time }}",
  "Program type": "Program type",
  "Successfully reported.": "Successfully reported.",
  "Small Business Development": "Small Business Development",
  "Financial Literacy": "Financial Literacy",
  "Health": "Health",
  "Mentoring & Career Development": "Mentoring & Career Development",
  "Parenting & Children": "Parenting & Children",
  "Advocacy & Social Justice": "Advocacy & Social Justice",
  "Clinical Trials": "Clinical Trials",
  "Inspirations": "Inspirations",
  "How to sign in": "How to sign in",
  "Updating your App": "Updating your App",
  "BigHeart Quick Start": "BigHeart Quick Start",
  "Troubleshooting": "Troubleshooting",
  "Various ways of signing in to our application.": "Various ways of signing in to our application.",
  "Check and Update your Android/iOS App.": "Check and Update your Android/iOS App.",
  "Features our app provides you.": "Features our app provides you.",
  "How to make a Donation via Google Pay/Apple Pay/Credit/Debit Card.": "How to make a Donation via Google Pay/Apple Pay/Credit/Debit Card.",
  "FAQ about common issues.": "FAQ about common issues.",
  "Art, Culture & Museums": "Art, Culture & Museums",
  "Education/Schools": "Education/Schools",
  "Environmental": "Environmental",
  "Food Pantries": "Food Pantries",
  "Mental Health": "Mental Health",
  "Personal Development": "Personal Development",
  "Shelters": "Shelters",
  "Sports": "Sports",
  "Visit details": "Visit details",
  "Transportation": "Transportation",
  "Telehealth Visit": "Telehealth Visit",
  "Only for members of Medical Communities": "Only for members of Medical Communities",
  "If you are experiencing a medical emergency or life-threatening medical condition, do NOT continue to request a virtual visit.": "If you are experiencing a medical emergency or life-threatening medical condition, do NOT continue to request a virtual visit.",
  "These symptoms include difficulty breathing or shortness of breath, chest pain or discomfort, dizziness, confusion, severe or persistent vomiting, and/or flu-like symptoms that improve then worsen again. Instead, immediately call 911 or go to your nearest emergency department.": "These symptoms include difficulty breathing or shortness of breath, chest pain or discomfort, dizziness, confusion, severe or persistent vomiting, and/or flu-like symptoms that improve then worsen again. Instead, immediately call 911 or go to your nearest emergency department.",
  "By clicking “Continue\" you are acknowledging that you are not experiencing a medical emergency and will continue to next step.": "By clicking “Continue\" you are acknowledging that you are not experiencing a medical emergency and will continue to next step.",
  "Fill out electronic form": "Fill out electronic form",
  "Call us on (773) 395-1830": "Call us on (773) 395-1830",
  "Important notice": "Important notice",
  "E-mail me a log in link": "E-mail me a log in link",
  "Log in link sent": "Log in link sent",
  "We have sent you an email with a log in link. Go to your inbox, check your email, and click the button with the log in link. It will redirect you back to this app and automatically log you in.": "We have sent you an email with a log in link. Go to your inbox, check your email, and click the button with the log in link. It will redirect you back to this app and automatically log you in.",
  "Link expires in": "Link expires in",
  "Back to log in page": "Back to log in page",
  "Log in link resent": "Log in link resent",
  "Log in link is invalid": "Log in link is invalid",
  "Log in link expired or was already used": "Log in link expired or was already used",
  "Logging you in": "Logging you in",
  "Quick Actions": "Quick Actions",
  "Request telehealth visit": "Request telehealth visit",
  "Request Telehealth Visit": "Request Telehealth Visit",
  "Choose community...": "Choose community...",
  "Medical community": "Medical community",
  "Choose type...": "Choose type...",
  "Patient type": "Patient type",
  "Visit type": "Visit type",
  "Visit type sub-option": "Visit type sub-option",
  "Choose sub-option...": "Choose sub-option...",
  "Why do you need consultation": "Why do you need consultation",
  "Info: Tell us the reason for your visit and your preferred date, time, and duration of the appointment.": "Info: Tell us the reason for your visit and your preferred date, time, and duration of the appointment.",
  "No community available for request.": "No community available for request.",
  "General Medical / Episodic Care sub-option": "General Medical / Episodic Care sub-option",
  "Telehealth visit was requested": "Telehealth visit was requested",
  "Select medical community": "Select medical community",
  "Please select community": "Please select community",
  "sub-option": "sub-option",
  "Please select": "Please select",
  "Duration": "Duration",
  "Contact me at": "Contact me at",
  "Failed to request contact": "Failed to request contact",
  "Duplicate Webinar / Webcast": "Duplicate Webinar / Webcast",
  "Duplicate video conference": "Duplicate webinar video conference",
  "Duplicate Event": "Duplicate Event",
  "Failed to duplicate event.": "Failed to duplicate event.",
  "Event was duplicated.": "Event was duplicated.",
  "Contact request sent": "Contact request sent",
  "Middle name": "Middle name",
  "Day": "Day",
  "Week": "Week",
  "Month": "Month",
  "Year": "Year",
  "more_communities_count_one": "and {{count}} other.",
  "more_communities_count_other": "and {{count}} others.",
  "Confirm consents to join": "Confirm consents to join",
  "Confirm consents": "Confirm consents",
  "Confirm Consents": "Confirm Consents",
  "Not now": "Not now",
  "You’re missing consents from following communities:": "You’re missing consents from following communities:",
  "To use the application, you must agree with policies. Without consent, it will not be possible to use the application.": "To use the application, you must agree with policies. Without consent, it will not be possible to use the application.",
  "Confirm": "Confirm",
  "Failed to confirm consent: {{name}}": "Failed to confirm consent: {{name}}",
  "Confirmed": "Confirmed",
  "To join this community, you must agree with policies. Without consent, you cannot join the community.": "To join this community, you must agree with policies. Without consent, you cannot join the community.",
  "Copy link": "Copy link",
  "Link copied successfully": "Link copied successfully",
  "Change Event": "Change Event",
  "Event cannot be deleted during approval process": "Event cannot be deleted during approval process",
  "Event cannot be changed during approval process": "Event cannot be changed during approval process",
  "Pending admin approval": "Pending admin approval",
  "Event was declined by admin": "Event was declined by admin",
  "We cannot allow this event because the number of invited members is exceeded.": "We cannot allow this event because the number of invited members is exceeded.",
  "Event is past due": "Event is past due",
  "Admin did’t approve the event in time for the start of the event.": "Admin did’t approve the event in time for the start of the event.",
  "Approved by admin": "Approved by admin",
  "The number of invitees cannot be increased, beyond the specified limit, in the published event.": "The number of invitees cannot be increased, beyond the specified limit, in the published event.",
  "This action is irreversible.": "This action is irreversible.",
  "Withings heart rate": "Withings heart rate",
  "Link for presenter copied to clipboard": "Link for presenter copied to clipboard",
  "Link for Attendee copied to clipboard": "Link for Attendee copied to clipboard",
  "Use password": "Use password",
  "Send email link": "Send email link",
  "All log in options": "All log in options",
  "Use password to log in": "Use password to log in",
  "Request new link": "Request new link",
  "Lowercase letter": "Lowercase letter",
  "At least 12 characters": "At least 12 characters",
  "Uppercase letter": "Uppercase letter",
  "Symbol: @#$%^&* etc.": "Symbol: @#$%^&* etc.",
  "Welcome to": "Welcome to ",
  "What’s next?": "What’s next?",
  "Event cover image": "Event cover image",
  "You're invited!": "You're invited!",
  "Please come back up to {{count}} minutes before the event starts": "Please come back up to {{count}} minutes before the event starts",
  "This event has ended": "This event has ended",
  "Join Event": "Join Event",
  "There was an error uploading the file": "There was an error uploading the file",
  "Go to events": "Go to events",
  "Providers": "Providers",
  "Patients / Guests": "Patients / Guests",
  "Link for patient / guest copied to clipboard": "Link for patient / guest copied to clipboard",
  "reminderInfo": "You can set your own reminders (how many days/hours/minutes before the end of the day user will be notified – f. ex.: when you set 4 hours before the end of the day, user will be notified at 8PM). Instead default values will be used.",
  "User removed successfully": "User removed successfully",
  "Something went wrong. The user could’t be removed.": "Something went wrong. The user could’t be removed.",
  "User with pending invitation cannot be removed": "User with pending invitation cannot be removed",
  "See All": "See All",
  "You're a member": "You're a member",
  "You've joined the {{ name }} organization": "You've joined the {{ name }} organization",
  "There was an error sending request to join community": "There was an error sending request to join community",
  "Yes, remove": "Yes, remove",
  "Profile": "Profile",
  "White Label": "White Label",
  "EHR Portal": "EHR Portal",
  "Redirecting to Admin console": "Redirecting to Admin console",
  "(e.g.: share your personal feedback to the webinar)": "(e.g.: share your personal feedback to the webinar)",
  "Get extended feedback or response from the user": "Get extended feedback or response from the user",
  "Get numeric value from the user": "Get numeric value from the user",
  "(e.g.: record your blood sugar value)": "(e.g.: record your blood sugar value)",
  "Physical activity": "Physical activity",
  "Withings blood pressure": "Withings blood pressure",
  "Redirecting to EHR Portal": "Redirecting to EHR Portal",
  "Remove user from?": "Remove {{fullName}} from {{groupName}}?",
  "Last updated on": "Last updated on {{lastUpdateTime, time}}",
  "Time left": "In {{timeLeft}}",
  "In progress time left": "{{timeLeft}}",
  "Go to your profile": "Go to your profile",
  "Confirm timezone": "Confirm timezone",
  "Confirm your timezone": "Confirm your timezone",
  "Timezone": "Timezone",
  "You can change the timezone in your profile.": "You can change the timezone in your profile.",
  "You can change it in Your Profile": "You can change it in Your Profile",
  "Please confirm that you’re currently located in the timezone displayed below.": "Please confirm that you’re currently located in the timezone displayed below.",
  "Well done on finishing your To-Dos for today": "Well done on finishing your To-Dos for today!",
  "Great job on completing your To-Dos for today": "Great job on completing your To-Dos for today!",
  "Your To-Do adventure starts here!": "Your To-Do adventure starts here!",
  "There are unread messages waiting for your attention. See what’s happening there": "There are <strong>{{unreadMessages}}</strong> unread messages waiting for your attention. See what’s happening there.",
  "There are new notifications waiting for your attention. See what’s happening there": "There are <strong>{{newNotifications}}</strong> new notifications waiting for your attention. See what’s happening there.",
  "Stay organized and accomplish tasks throughout the day. Explore more features as you complete your To-Dos or wait for new ones": "Stay organized and accomplish tasks throughout the day. Explore more features as you complete your To-Dos or wait for new ones.",
  "If all To-Dos are completed, user has no To-Dos for that day, all messages are read, all notifications are read or user opens app for the first time and has no To-Dos yet": "If all To-Dos are completed, user has no To-Dos for that day, all messages are read, all notifications are read or user opens app for the first time and has no To-Dos yet",
  "Check my messages": "Check my messages",
  "Open notifications": "Open notifications",
  "See what’s happening": "See what’s happening",
  "Mark activity as completed": "Mark activity as completed",
  "Activity marked as completed": "Activity marked as completed",
  "You have no upcoming events": "You have no upcoming events",
  "You have no past events": "You have no past events",
  "Add Users to General BigHeart Community": "Add Users to General BigHeart Community",
  "No, I'm not going": "No, I'm not going",
  "There are no programs to explore yet": "There are no programs to explore yet",
  "Forgot password": "Forgot password",
  "More communities": "More communities",
  "morePills": "+{{ pillsNumber }} more",
  "Continue to billing information": "Continue to billing information",
  "Continue to donation page": "Continue to donation page",
  "Custom amount": "Custom amount",
  "Thank you for donation!": "Thank you for donation!",
  "Select amount": "Select amount",
  "Fill billing information": "Fill billing information",
  "Select donation type": "Select donation type",
  "There was a problem processing your payment": "There was a problem processing your payment",
  "Unknown user": "Unknown user",
  "user": "user",
  "likesCount_zero": "Like",
  "likesCount_one": "{{count}} Like",
  "likesCount_other": "{{count}} Likes",
  "commentsCount_one": "{{count}} Comment",
  "commentsCount_other": "{{count}} Comments",
  "Discover new public content curated by BigHeart. Browse through channels for programs and communities to find what interests you.": "Discover new public content curated by BigHeart. Browse through channels for programs and communities to find what interests you.",
  "Channels": "Channels",
  "Sign in with Google": "Sign in with Google",
  "MY": "MY",
  "View": "View",
  "You haven’t registered for any program yet": "You haven’t registered for any program yet",
  "Discover new content that is right for you in our Channels": "Discover new content that is right for you in our Channels",
  "Featured": "Featured",
  "Non-featured": "Non-featured",
  "Program cover image": "Program cover image",
  "This channel is empty": "This channel is empty",
  "There is nothing available for this channel yet or you’ve joined all the content already": "There is nothing available for this channel yet or you’ve joined all the content already",
  "errorUserAlreadyInvited": "Failed to invite users. User/s already invited.",
  "Telehealth visit has been created already": "Telehealth visit has been created already",
  "The event you're trying to create has already been created": "The event you're trying to create has already been created",
  "Request for Telehealth Visit denied": "Request for Telehealth Visit denied",
  "The request you're trying to access has been denied already. Please go back to Admin Console and select Denied requests.": "The request you're trying to access has been denied already. Please go back to Admin Console and select Denied requests.",
  "Request for Telehealth Visit expired": "Request for Telehealth Visit expired",
  "The request you're trying to access has expired already": "The request you're trying to access has expired already",
  "The password must contain following": "The password must contain following",
  "StepCompleted": "Step {{stepNumber}} - Completed",
  "StepWithNumber": "Step {{stepNumber}}",
  "Source": "Source",
  "Push": "Push",
  "On": "On",
  "Off": "Off",
  "All notifications": "All notifications",
  "Enable/disable all email notifications": "Enable/disable all email notifications",
  "Enable/disable all push notifications": "Enable/disable all push notifications",
  "email notifications settings for": "Email notifications settings for {{ value }}",
  "push notifications settings for": "push notifications settings for {{value}}",
  "I understand": "I understand",
  "Good morning, {{name}}": "Good morning, {{name}}",
  "Good afternoon, {{name}}": "Good afternoon, {{name}}",
  "Good evening, {{name}}": "Good evening, {{name}}",
  "Error: E-mail is not valid. Please enter a valid email address (e.g., example@email.com)": "Error: E-mail is not valid. Please enter a valid email address (e.g., example@email.com)",
  "Error: New password must be different from the current password.": "New password must be different from the current password.",
  "Error: ${label} cannot be a blank character": "Error: ${label} cannot be a blank character",
  "Error: ${label} is not a valid number": "Error: ${label} is not a valid number",
  "Select tags": "Select tags",
  "Error: Date and time cannot be in the past": "Error: Date and time cannot be in the past",
  "Pin program as featured in Channels": "Pin program as featured in Channels",
  "Error: ${label} is required": "Error: ${label} is required",
  "Share on LinkedIn": "Share on LinkedIn",
  "It prevents program members from leaving the program after they are invited to the program. Automatically joins new community members of the invited communities to the program.": "It prevents program members from leaving the program after they are invited to the program. Automatically joins new community members of the invited communities to the program.",
  "Status": "Status",
  "Share on Facebook": "Share on Facebook",
  "Repost": "Repost",
  "Link copied to clipboard": "Link copied to clipboard",
  "Share via email": "Share via email",
  "There are no programs to display here": "There are no programs to display here",
  "Please confirm you are using your legal name and the information below is correct by clicking the continue button below. After confirmation, any changes will be reflected in your profile.": "Please confirm you are using your legal name and the information below is correct by clicking the continue button below. After confirmation, any changes will be reflected in your profile.",
  "Confirm your information": "Confirm your information",
  "Go to channels": "Go to channels",
  "Error: Phone number is required. Please enter a valid phone number (e.g., 201 555 0123)": "Error: Phone number is required. Please enter a valid phone number (e.g., 201 555 0123)",
  "Invite Members": "Invite Members",
  "Search": "Search",
  "There are no communities to display here": "There are no communities to display here",
  "Tags": "Tags",
  "Show less": "Show less",
  "Notifications disabled": "Notifications disabled",
  "Either notifications are disabled by default in this community, or your global notifications are turned off": "Either notifications are disabled by default in this community, or your global notifications are turned off",
  "Choose interests (more options to choose from)": "Choose interests (more options to choose from)",
  "Event was already rated": "Event was already rated",
  "Authentication failed": "Authentication failed",
  "Failed to send reset link": "Failed to send reset link",
  "Your account has been locked for 30 minutes after 5 failed attempts to login. After this period, your account will be available with current credentials.": "Your account has been locked for 30 minutes after 5 failed attempts to login. After this period, your account will be available with current credentials.",
  "If you wish to unlock your account sooner, you need to reset your password.": "If you wish to unlock your account sooner, you need to reset your password.",
  "There are no channels yet or you’ve joined all the content already": "There are no channels yet or you’ve joined all the content already",
  "No channels yet ": "No channels yet",
  "Show event in Channels": "Show event in Channels",
  "Pin event as featured in Channels": "Pin event as featured in Channels",
  "Event will display in your organization’s channels. Everyone in your organization will be able to join the event.": "Event will display in your organization’s channels. Everyone in your organization will be able to join the event.",
  "Event will appear as featured in Channels.": "Event will appear as featured in Channels.",
  "Visibility in channels": "Visibility in channels",
  "Event": "Event",
  "Giving cover image": "Giving cover image",
  "Community will display in your organization’s channels. Everyone in your organization will be able join this community.": "Community will display in your organization’s channels. Everyone in your organization will be able join this community.",
  "Community will appear as featured in the Channels": "Community will appear as featured in the Channels",
  "Pin Community as featured in Channels": "Pin Community as featured in Channels",
  "Show community in Channels": "Show community in Channels",
  "Show program in Channels": "Show program in Channels",
  "Skip": "Skip",
  "Rate the Event": "Rate the Event",
  "How useful was the event?": "How useful was the event?",
  "What would improve your event experience?": "What would improve your event experience?",
  "Rate the Audio Quality": "Rate the Audio Quality",
  "How would you rate the audio quality?": "How would you rate the audio quality?",
  "What would improve your audio quality?": "What would improve your audio quality?",
  "Rate the Video Quality": "Rate the Video Quality",
  "How would you rate the video quality?": "How would you rate the video quality?",
  "What would improve your video quality?": "What would improve your video quality?",
  "Error: Please provide publish date": "Error: Please provide publish date",
  "Error: Post publish date must be set after Program start time": "Error: Post publish date must be set after Program start time",
  "Error: Post publish date must be set before Program end time": "Error: Post publish date must be set before Program end time",
  "Publish date": "Publish date",
  "Read post": "Read post",
  "Optional": "Optional",
  "Error: To-Do due date must be set after Program start time": "Error: To-Do due date must be set after Program start time",
  "Error: To-Do due date must be set before Program end time": "Error: To-Do due date must be set before Program end time",
  "Error: Due to date must be set after the publish date": "Error: Due to date must be set after the publish date",
  "loginHelpText": "If you didn't receive the log in link, please try again or <1>sign up.</1>",
  "Anyone in the BigHeart ecosystem can explore and join public communities.": "Anyone in the BigHeart ecosystem can explore and join public communities.",
  "Members join a secret community by invitation only. It is not searchable on the platform.": "Members join a secret community by invitation only. It is not searchable on the platform.",
  "Anyone in the BigHeart ecosystem can explore and request to join private communities. The community admin approves or denies the request to join.": "Anyone in the BigHeart ecosystem can explore and request to join private communities. The community admin approves or denies the request to join.",
  "No description available": "No description available",
  "Join video": "Join video",
  "Post marked as read successfully": "Post marked as read successfully",
  "Failed to mark post as read": "Failed to mark post as read",
  "Mark as read": "Mark as read",
  "Marked as read": "Marked as read",
  "The selected organization is using ": "The selected organization is using ",
  "The selected community is part of an organization that is using": "The selected community is part of an organization that is using",
  "custom": "custom",
  "default": "default",
  "channels": "channels",
  "Got it": "Got it",
  "Select version": "Select version",
  "Here's what's new! The latest release includes new features, improvements, and bug fixes to make your experience better than ever": "Here's what's new! The latest release includes new features, improvements, and bug fixes to make your experience better than ever",
  "Like": "Like",
  "Name of company/school": "Name of company/school",
  "Error: You can choose only 3 interests": "Error: You can choose only 3 interests",
  "We cannot allow images from unknown sources for security reasons. Please use the regular upload method to submit your images.": "We cannot allow images from unknown sources for security reasons. Please use the regular upload method to submit your images.",
  "Inviting the entire communities or organizations can result in a large number of invitations being sent. Please review the selection carefully before submitting to avoid any errors.": "Inviting the entire communities or organizations can result in a large number of invitations being sent. Please review the selection carefully before submitting to avoid any errors.",
  "This option is available only for super admins. If you need to set this program to Public, please contact a super admin for assistance.": "This option is available only for super admins. If you need to set this program to Public, please contact a super admin for assistance.",
  "This option is available only for super admins. If you need to set this community to Public, please contact a super admin for assistance.": "This option is available only for super admins. If you need to set this community to Public, please contact a super admin for assistance.",
  "No data": "No data",
  "No tags available. The selected community is in an organization that has no tags defined.": "No tags available. The selected community is in an organization that has no tags defined.",
  "time_tag_at": "At {{ date, time }}",
  "time_tag_by": "By {{ date, time }}",
  "time_tag_live": "Live",
  "Respond to invitation": "Respond to invitation",
  "Join event": "Join event",
  "Complete activity": "Complete activity",
  "Complete poll": "Complete poll",
  "Order device": "Order device",
  "No tags available": "No tags available",
  "No tags available. The selected organization has no tags defined.": "No tags available. The selected organization has no tags defined.",
  "Or, continue in browser": "Or, continue in browser",
  "Please continue to enter your custom amount in Stripe.": "Please continue to enter your custom amount in Stripe.",
  "Requests are generally reviewed withing 24 hours": "Requests are generally reviewed withing 24 hours",
  "Full name": "Full name",
  "Error: Accepting Terms & Conditions is required": "Error: Accepting Terms & Conditions is required",
  "Error: {{label}} is still in process of uploading": "Error: {{label}} is still in process of uploading",
  "Hello {{firstName}}!": "Hello {{firstName}}!",
  "onboardingTourWelcomeSubtitle_one": "In the next {{count}} step, we need your help to customize your experience on our platform.",
  "onboardingTourWelcomeSubtitle_other": "In the next {{count}} steps, we need your help to customize your experience on our platform.",
  "Get started": "Get started",
  "Step {{current}} of {{total}}": "Step {{current}} of {{total}}",
  "Make it yours!": "Make it yours!",
  "To continue, please read and agree to our standard consents.": "To continue, please read and agree to our standard consents.",
  "Avatar": "Avatar",
  "Other details": "Other details",
  "Interests": "Interests",
  "Add photo": "Add photo",
  "Onboarding": "Onboarding",
  "Express yourself with a profile picture! Your phone number, date of birth, and timezone are only shared with your organization’s administrators.": "Express yourself with a profile picture! Your phone number, date of birth, and timezone are only shared with your organization’s administrators.",
  "Welcome {{firstName}}!": "Welcome {{firstName}}!",
  "Thank you for signing up! Now you're ready to enjoy the app.": "Thank you for signing up! Now you're ready to enjoy the app.",
  "Let’s go": "Let’s go",
  "Info": "Info",
  "Unsync": "Unsync",
  "Sync": "Sync",
  "Google": "Google",
  "Outlook": "Outlook",
  "Apple": "Apple",
  "Error: Consent for {{label}} is required": "Error: Consent for {{label}} is required",
  "Error during accessing file": "Error during accessing file",
  "Error during file upload": "Error during file upload",
  "Abort file upload": "Abort file upload",
  "Going": "Going",
  "Not going": "Not going",
  "By completing the following order, you will receive Health devices free of charge": "By completing the following order, you will receive Health devices free of charge",
  "I agree to the": "I agree to the",
  "Terms & Conditions": "Terms & Conditions",
  "Order completeness was successful": "Order completeness was successful",
  "You successfully finished the order form. You will receive an e-mail when we will ship the Withings devices to your delivery address.": "You successfully finished the order form. You will receive an e-mail when we will ship the Withings devices to your delivery address.",
  "Something went wrong. The post could not be created.": "Something went wrong. The post could not be created.",
  "Failed to connect to Google account.": "Failed to connect to Google account.",
  "Attachment ({{count}})": "Attachment ({{count}})",
  "Write comment...": "Write comment...",
  "Attachments ({{count}})": "Attachments ({{count}})",
  "Clear all": "Clear all",
  "The attachment upload is still in progress. You can submit the post after the upload is finished.": "The attachment upload is still in progress. You can submit the post after the upload is finished.",
  "Error: Post cannot be empty": "Error: Post cannot be empty",
  "Release notes": "Release notes",
  "MY STUFF": "MY STUFF",
  "Go to Communities": "Go to Communities",
  "Go to Programs": "Go to Programs",
  "Go to Videos": "Go to Videos",
  "Complete now": "Complete now",
  "Uploaded item is not a File object": "Uploaded item is not a File object",
  "The conversation is about to begin": "The conversation is about to begin",
  "Be first to add a comment and start a discussion": "Be first to add a comment and start a discussion",
  "Repost successful": "Repost successful",
  "Create post": "Create post",
  "Select your organization": "Select your organization",
  "{{organizationName}} photo": "{{organizationName}} photo",
  "Save all": "Save all",
  "Files cannot be downloaded, please try again later.": "Files cannot be downloaded, please try again later.",
  "Account doesn’t exist": "Account doesn’t exist",
  "Account you are trying to log in to, doesn’t exist. Please proceed with Sign up and create your account first.": "Account you are trying to log in to, doesn’t exist. Please proceed with Sign up and create your account first.",
  "Bi-weekly": "Bi-weekly",
  "Add video": "Add video",
  "Choose organization": "Choose organization",
  "Video added successfully": "Video added successfully",
  "Something went wrong, video couldn’t be added": "Something went wrong, video couldn’t be added",
  "Videos": "Videos",
  "Recorded at": "Recorded at",
  "File uploaded successfully": "File uploaded successfully",
  "There are no organizations to display here": "There are no organizations to display here",
  "Organization cover image": "Organization cover image",
  "Processing videos": "Processing videos",
  "We’re processing your video files. This may take a short while.": "We’re processing your video files. This may take a short while.",
  "Upload a short video to get members interested. Members can always play this video for free.": "Upload a short video to get members interested. Members can always play this video for free.",
  "Upload the full-length video here. If you've decided to add a price for the video, members will have to pay before they can view this video.": "Upload the full-length video here. If you've decided to add a price for the video, members will have to pay before they can view this video.",
  "Click or drag file to this area to upload": "Click or drag file to this area to upload",
  "Support for a single file only": "Support for a single file only",
  "Details": "Details",
  "Members can join after admin’s approval": "Members can join after admin’s approval",
  "Any member can join": "Any member can join",
  "Member must be invited to be able to join": "Member must be invited to be able to join",
  "No giving found": "No giving found",
  "Currently, there is no active giving to display.": "Currently, there is no active giving to display.",
  "Video (Draft)": "Video (Draft)",
  "formattedMembersCount_one": "{{formattedCount}} member",
  "formattedMembersCount_other": "{{formattedCount}} members",
  "The selected organization is using <strong>{{channelType}}</strong> channels": "The selected organization is using <strong>{{channelType}}</strong> channels",
  "Error: Selected tags are not valid for current organization": "Error: Selected tags are not valid for current organization",
  "Members will see this image preview in Channels and My Content.": "Members will see this image preview in Channels and My Content.",
  "Show video in Channels": "Show video in Channels",
  "Video will display in your organization’s channels.<br/>Everyone in your organization will be able access this video.": "Video will display in your organization’s channels.<br/>Everyone in your organization will be able access this video.",
  "Pin video as featured in Channels": "Pin video as featured in Channels",
  "Video will appear as featured in the Channels": "Video will appear as featured in the Channels",
  "Error: File has incorrect aspect ratio {{widthAspect}}:{{heightAspect}}": "Error: File has incorrect aspect ratio {{widthAspect}}:{{heightAspect}}",
  "Sort": "Sort",
  "Group cover photo": "Group cover photo",
  "Hierarchy": "Hierarchy",
  "Church": "Church",
  "District": "District",
  "Jurisdiction": "Jurisdiction",
  "Region": "Region",
  "Association": "Association",
  "Denomination": "Denomination",
  "Private Label App": "Private Label App",
  "State Convention": "State Convention",
  "Video successfully deleted.": "Video successfully deleted.",
  "Failed to delete video": "Failed to delete video",
  "Video successfully edited": "Video successfully edited",
  "Edit video": "Edit video",
  "Join Organization": "Join Organization",
  "Organization cover photo": "Organization cover photo",
  "Video (Archived)": "Video (Archived)",
  "Associations": "Associations",
  "Denominations": "Denominations",
  "Private Label Apps": "Private Label Apps",
  "Districts": "Districts",
  "Jurisdictions": "Jurisdictions",
  "Regions": "Regions",
  "State conventions": "State conventions",
  "No churches": "No churches",
  "There are no churches to display here": "There are no churches to display here",
  "Are you sure you want to delete {{name}}?": "Are you sure you want to delete {{name}}?",
  "Are you sure you want to report {{name}}?": "Are you sure you want to report {{name}}?",
  "Churches": "Churches",
  "Group profile photo": "Group profile photo",
  "Organization profile photo": "Organization profile photo",
  "Click the Google Play button below to download the app.": "Click the Google Play button below to download the app.",
  "Click the Install button in the top banner to download the app from the App Store.": "Click the Install button in the top banner to download the app from the App Store.",
  "Go to Calendar": "Go to Calendar",
  "Go to Givings": "Go to Givings",
  "No channels": "No channels",
  "There are no channels to display here": "There are no channels to display here",
  "Giving Dashboard": "Giving Dashboard",
  "Error: You must agree to the terms and conditions": "Error: You must agree to the terms and conditions",
  "Value": "Value",
  "Unsupported option: {{option}}": "Unsupported option: {{option}}",
  "Event cover photo": "Event cover photo",
  "Webinar": "Webinar",
  "Are you sure you want ot remove your account?": "Are you sure you want ot remove your account?",
  "Account removal requested": "Account removal requested",
  "date_by_time": "By {{date, shortMonthDay}} at {{date, time}}",
  "date_time": "{{date, shortMonthDay}} at {{date, time}}",
  "date_year_by_time": "By {{date, shortMonthDayYear}} at {{date, time}}",
  "date_year_time": "{{date, shortMonthDayYear}} at {{date, time}}",
  "Appearance": "Appearance",
  "Visible": "Visible",
  "Object will be visible as featured in Channels": "Object will be visible as featured in Channels",
  "Object will be visible in Channels": "Object will be visible in Channels",
  "dateFormatTimeRange": "{{ dateFrom, time }} - {{ dateTo, time }}",
  "dateFormatShortMonthDayRangeWithYear": "{{dateFrom, shortMonthDay}} - {{dateTo, shortMonthDayYear}}",
  "pending": "{{count}} pending",
  "Error: Select month": "Error: Select month",
  "Error: Select day": "Error: Select day",
  "Error: Select year": "Error: Select year",
  "Error: Number of days in month is not valid": "Error: Number of days in month is not valid",
  "Error: Date of birth is not valid": "Error: Date of birth is not valid",
  "Error: The attachment upload is still in progress.": "Error: The attachment upload is still in progress.",
  "Error: ${label} cannot be longer than ${max} characters": "Error: ${label} cannot be longer than ${max} characters",
  "Error: Poll start time must be set after Program start time": "Error: Poll start time must be set after Program start time",
  "Error: Poll end time must be set before Program end time": "Error: Poll end time must be set before Program end time",
  "Error: Activity start time must be set after Program start time": "Error: Activity start time must be set after Program start time",
  "Error: Activity end time must be set before Program end time": "Error: Activity end time must be set before Program end time",
  "You didn’t respond": "You didn’t respond",
  "months_one": "month",
  "months_other": "months",
  "days_one": "day",
  "days_other": "days",
  "hours_one": "hour",
  "hours_other": "hours",
  "mins_one": "min",
  "mins_other": "mins",
  "secs_one": "sec",
  "secs_other": "secs",
  "Event starts in": "Event starts in",
  "Giving offering": "Offering",
  "Giving donation": "Donation",
  "Giving tithe": "Tithe",
  "Giving crowdfunding": "Crowdfunding",
  "Donations {{participants}}": "Donations ({{participants}})",
  "This action is irreversible!": "This action is irreversible!",
  "Something went wrong. The event couldn’t be deleted.": "Something went wrong. The event couldn’t be deleted.",
  "We will notify admins of your organization": "We will notify admins of your organization",
  "Event has been reported to admins of your organization.": "Event has been reported to admins of your organization.",
  "Something went wrong. The report couldn’t be sent.": "Something went wrong. The report couldn’t be sent.",
  "Use the address in my profile for billing": "Use the address in my profile for billing",
  "Update information also in my profile": "Update information also in my profile",
  "Preset amounts": "Preset amounts",
  "Set custom amount": "Set custom amount",
  "Make my gift recurring": "Make my gift recurring",
  "How often would you like to send this gift?": "How often would you like to send this gift?",
  "Testimonial": "Testimonial",
  "Display my name and photo with my gift": "Display my name and photo with my gift",
  "Display my name with my gift": "Display my name with my gift",
  "You will be charged only once": "You will be charged only once",
  "Do not display my name and photo with my gift": "Do not display my name and photo with my gift",
  "Do not display my name with my gift": "Do not display my name with my gift",
  "Continue to payment": "Continue to payment",
  "My giving options": "My giving options",
  "We apologize for the inconvenience, but the Id of the selected price option was not found in our system due to a technical error.": "We apologize for the inconvenience, but the Id of the selected price option was not found in our system due to a technical error.",
  "It will be displayed here once it’s ready.": "It will be displayed here once it’s ready.",
  "The video recording is being processed.": "The video recording is being processed.",
  "We’re waiting for admin to approve": "We’re waiting for admin to approve",
  "Declined by admin": "Declined by admin",
  "Past due": "Past due",
  "This event is allowed since the admin has approved exceeding the member limit.": "This event is allowed since the admin has approved exceeding the member limit.",
  "Approved": "Approved",
  "Dial-in": "Dial-in",
  "App Language": "App Language",
  "The selected language determines the application’s interface language": "The selected language determines the application’s interface language",
  "The selected language will be used to translate posts, polls, and other content": "The selected language will be used to translate posts, polls, and other content",
  "All community members are invited and can join": "All community members are invited and can join",
  "Selected community members": "Selected community members",
  "Only selected community members are invited and can join": "Only selected community members are invited and can join",
  "Community profile photo": "Community profile photo",
  "Program profile photo": "Program profile photo",
  "Invitation link successfully copied to clipboard": "Invitation link successfully copied to clipboard",
  "Invitations sent successfully": "Invitations sent successfully",
  "Invitations sent successfully to non-members": "Invitations sent successfully to non-members",
  "Thank you for your generosity": "Thank you for your generosity",
  "Congratulations! Your gift has been successfully processed.": "Congratulations! Your gift has been successfully processed.",
  "We sincerely appreciate your support.": "We sincerely appreciate your support.",
  "Additionally, we would be immensely grateful if you could share your giving with your friends and family. Together, we can make a difference and spread the word about our cause.": "Additionally, we would be immensely grateful if you could share your giving with your friends and family.  Together, we can make a difference and spread the word about our cause.",
  "We couldn’t process your gift. Please try again later.": "We couldn’t process your gift. Please try again later.",
  "Linkedin": "Linkedin",
  "Facebook": "Facebook",
  "Giving successful": "Giving successful",
  "Giving failed": "Giving failed",
  "Thank you once again for your generosity and support!": "Thank you once again for your generosity and support!",
  "Giving email share subject": "Join Me in Supporting This Meaningful Giving!",
  "Giving email share body": "Hello,\n\n I just contributed to a meaningful cause, and I’d love for you to check it out. Every gift makes a difference!\n\nGiving: {{givingName}}\nLearn More & Give Here: {{givingPublicUrl}}\n\nTogether, we can create a lasting impact. If this cause speaks to your heart, I encourage you to join me in giving.\n\nBlessings",
  "The request will be sent to admin. After admin's approval, your account will be removed. In the meantime you will be logged out.": "The request will be sent to admin. After admin's approval, your account will be removed. In the meantime you will be logged out.",
  "{{fileName}} is not valid image.": "{{fileName}} is not valid image.",
  "Value is uploading": "Value is uploading",
  "Give by check": "Give by check",
  "Pledge my gift": "Pledge my gift",
  "Give": "Give",
  "My giving summary": "My giving summary",
  "Total amount": "Total amount",
  "Give now": "Give now",
  "Browse": "Browse",
  "Add amount": "Add amount",
  "Latest confirmed invitees": "Latest confirmed invitees",
  "Type email address and press enter, space or comma - Or paste from a spreadsheet!": "Type email address and press enter, space or comma - Or paste from a spreadsheet!",
  "You must be logged in to enter this event": "You must be logged in to enter this event",
  "Join live": "Join live",
  "Please come back later.": "Please come back later.",
  "The event has ended": "The event has ended",
  "Error: Some phone numbers are invalid. The number must start with area code + and must not contain any spaces. Example: +12133734253": "Error: Some phone numbers are invalid. The number must start with area code + and must not contain any spaces. Example: +12133734253",
  "Type phone numbers and press enter, space or comma - Or paste from a spreadsheet!": "Type phone numbers and press enter, space or comma - Or paste from a spreadsheet!",
  "You can display the QR code for someone nearby, share it through messaging apps, or download it to your device for later use": "You can display the QR code for someone nearby, share it through messaging apps, or download it to your device for later use",
  "By scanning the QR code, the recipient can accept the invitation and join the platform seamlessly. The process is quick and straightforward.": "By scanning the QR code, the recipient can accept the invitation and join the platform seamlessly. The process is quick and straightforward.",
  "Please select at least one giving option": "You need to add at least one item to proceed",
  "You are a member of multiple organizations. Please select an organization to proceed with Give Now": "You are a member of multiple organizations. Please select an organization to proceed with Give Now",
  "No giving": "No giving",
  "No giving for this organization": "No giving for this organization",
  "It looks like there is no giving available in Give now at the moment. Please check back later or contact your organization’s admin for more information.": "It looks like there is no giving available in Give now at the moment. Please check back later or contact your organization’s admin for more information.",
  "There is currently no giving available for this organization in Give Now.  Please check back later or contact your organization’s admin for more information.": "There is currently no giving available for this organization in Give Now.  Please check back later or contact your organization’s admin for more information.",
  "(You)": "(You)",
  "Accepted ({{count}})": "Accepted ({{count}})",
  "{{invitees}} accepted": "{{invitees}} accepted",
  "accepted": "{{count}} accepted",
  "declined": "{{count}} declined",
  "Accepted": "Accepted",
  "Declined": "Declined",
  "Patient / Guest": "Patient / Guest",
  "Provider": "Provider",
  "Attendee": "Attendee",
  "Admin / Host": "Admin / Host",
  "Presenter": "Presenter",
  "Role": "Role",
  "Invite users": "Invite users",
  "All invitees": "All invitees",
  "Anonymous": "Anonymous",
  "Testimonial successfully edited": "Testimonial successfully edited",
  "Testimonial successfully deleted": "Testimonial successfully deleted",
  "Are you sure you want to report this testimonial?": "Are you sure you want to report this testimonial?",
  "Testimonial has been reported to admins of your organization.": "Testimonial has been reported to admins of your organization.",
  "Are you sure you want to delete this testimonial?": "Are you sure you want to delete this testimonial?",
  "Testimonial successfully deleted.": "Testimonial successfully deleted.",
  "Something went wrong. The testimonial couldn’t be deleted.": "Something went wrong. The testimonial couldn’t be deleted.",
  "paymentAge": "{{ date, age }} ago",
  "{{recurringOption}} donor since {{startDate}}": "{{recurringOption}} donor since {{startDate}}",
  "testimonialAge": "{{ date, age }} ago",
  "comments_zero": "Comments",
  "comments_one": "Comments ({{count}})",
  "comments_other": "Comments ({{count}})",
  "Add comment": "Add comment",
  "Top donors": "Top donors",
  "top": "top",
  "recent": "recent",
  "Recent donations": "Recent donations",
  "Do you want to duplicate event with all invitees?": "Do you want to duplicate event with all invitees?",
  "There will be no attendees for this event, once this event is duplicated": "There will be no attendees for this event, once this event is duplicated",
  "All current invitees will get invitations for this event": "All current invitees will get invitations for this event",
  "Yes": "Yes",
  "Invitees": "Invitees",
  "View in admin console": "View in admin console",
  "Hero image": "Hero image",
  "Redirecting to Stripe portal": "Redirecting to Stripe portal",
  "My Financial Transactions": "My Financial Transactions",
  "Something went wrong. Invitations couldn’t been sent.": "Something went wrong. Invitations couldn’t been sent.",
  "Change to admin": "Change to admin",
  "Change to attendee": "Change to attendee",
  "Change to presenter": "Change to presenter",
  "Change to provider": "Change to provider",
  "Change to patient": "Change to patient",
  "Remove from event": "Remove from event",
  "{{name}}’s role changed to {{role}}": "{{name}}’s role changed to {{role}}",
  "Something went wrong. {{name}}’s role couldn’t be changed.": "Something went wrong. {{name}}’s role couldn’t be changed.",
  "Are you sure you want to remove {{name}} from this event?": "Are you sure you want to remove {{name}} from this event?",
  "{{name}} removed from event successfully": "{{name}} removed from event successfully",
  "Something went wrong. {{name}} couldn’t be removed from event.": "Something went wrong. {{name}} couldn’t be removed from event.",
  "Invite friends": "Invite friends",
  "Fetch primary user failed": "Fetch primary user failed",
  "Fetch secondary user failed": "Fetch secondary user failed",
  "Failed to fetch both users": "Failed to fetch both users",
  "Recurring": "Recurring",
  "Periodicity": "Periodicity",
  "Link for presenter copied successfully": "Link for presenter copied successfully",
  "Link for attendee copied successfully": "Link for attendee copied successfully",
  "Link for patient / guest copied successfully": "Link for patient / guest copied successfully",
  "Send message": "Send message",
  "Profile completeness": "Profile completeness",
  "Languages": "Languages",
  "Change password": "Change password",
  "Age": "Age",
  "Location": "Location",
  "Company / School": "Company / School",
  "under_18": "Under 18",
  "18_to_24": "18 to 24",
  "25_to_34": "25 to 34",
  "35_to_44": "35 to 44",
  "45_to_54": "45 to 54",
  "55_to_64": "55 to 64",
  "65_or_over": "65 or over",
  "Unknown": "Unknown",
  "{{name}}s post": "{{name}}’s post",
  "{{name}}s event": "{{name}}’s event",
  "Load previous comments ": "Load previous comments",
  "Read more": "Read more",
  "Read less": "Read less",
  "Edit profile": "Edit profile",
  "Member cover photo": "Member cover photo",
  "Home Address": "Home Address",
  "Other Details": "Other Details",
  "Birthdate": "Birthdate",
  "Uploaded image": "Uploaded image",
  "User profile photo": "User profile photo",
  "User cover photo": "User cover photo",
  "My Profile": "My Profile",
  "Joined programs": "Joined programs",
  "Joined organizations": "Joined organizations",
  "Joined communities": "Joined communities",
  "Any announcements will show up here once they’re created": "Any announcements will show up here once they’re created",
  "No announcements yet": "No announcements yet",
  "Create announcement": "Create announcement",
  "Are you sure you want to report this announcement?": "Are you sure you want to report this announcement?",
  "Are you sure you want to report this post?": "Are you sure you want to report this post?",
  "Request": "Request",
  "listUserName": "{{name}} (You)",
  "userAvatarProfilePhoto": "{{name}} - profile photo",
  "User hasn’t filled any info yet": "User hasn’t filled any info yet",
  "Preview": "Preview",
  "at": "at",
  "{{participants}} enrolled": "{{participants}} enrolled",
  "formattedDonorsCount_one": "{{formattedCount}} unique donor",
  "formattedDonorsCount_other": "{{formattedCount}} unique donors",
  "{{invitees}} going": "{{invitees}} going",
  "webinar": "Webinar",
  "conference": "Video Conference",
  "telehealth_visit": "Telehealth Visit",
  "To-Dos for": "To-Dos for",
  "Tomorrow": "Tomorrow",
  "Language updated successfully": "Language updated successfully",
  "Write content...": "Write content...",
  "You can invite this user again at any time.": "You can invite this user again at any time.",
  "attendee": "attendee",
  "admin": "admin",
  "presenter": "presenter",
  "patient": "patient",
  "provider": "provider",
  "To-Dos for today": "To-Dos for Today ({{numberOfTodos}})",
  "Your {{content}} has been published": "Your {{content}} has been published",
  "post": "post",
  "announcement": "announcement",
  "Announcements": "Announcements",
  "Successfully updated": "Successfully updated",
  "No To-Dos for tomorrow": "No To-Dos for tomorrow",
  "Any to-dos assigned to you for tomorrow will appear here": "Any to-dos assigned to you for tomorrow will appear here",
  "You can only invite friends to public communities": "You can only invite friends to public communities",
  "QR code": "QR code",
  "Member select": "Member select",
  "How would you like to invite your friends?": "How would you like to invite your friends?",
  "Invite via QR code": "Invite via QR code",
  "Select members to invite": "Select members to invite",
  "Invite via e-mail": "Invite via e-mail",
  "Send invitations": "Send invitations",
  "There are no channels here yet": "There are no channels here yet",
  "There are no channels here. Try scrolling through the tabs above to find BigHeart, where you can explore interesting content.": "There are no channels here. Try scrolling through the tabs above to find BigHeart, where you can explore interesting content.",
  "No channels in this organization": "No channels in this organization",
  "Or click the App Store button below to download the app.": "Or click the App Store button below to download the app.",
  "What&apos;s next?": "What's next?",
  "Click the “Get” button above": "Click the “Get” button above",
  "Try adjusting your search or filters": "Try adjusting your search or filters",
  "No videos found": "No videos found",
  "Your videos will appear here": "Your videos will appear here",
  "No videos yet": "No videos yet",
  "View in Admin Console": "View in Admin Console",
  "You don’t have any upcoming events at the moment": "You don’t have any upcoming events at the moment",
  "You don’t have any past events at the moment": "You don’t have any past events at the moment",
  "No events yet": "No events yet",
  "Share via QR code": "Share via QR code",
  "shareQrCodeEntityName": "{{entityName}} Share QR Code",
  "Recording available": "Recording available",
  "Make sure this is intentional.": "Make sure this is intentional.",
  "You are inviting more than {{count}} invitees!": "You are inviting more than {{count}} invitees!",
  "This requires approval from the admin. During approval process, event cannot be changed.": "This requires approval from the admin. During approval process, event cannot be changed.",
  "This program event is in an object that has not been published yet.": "This program event is in an object that has not been published yet.",
  "Not published": "Not published",
  "If you leave now, your progress will be discarded. You’ll need to go back to Admin Console to start the process again.": "If you leave now, your progress will be discarded. You’ll need to go back to Admin Console to start the process again.",
  "Leave Telehealth visit creation?": "Leave Telehealth visit creation?",
  "Admin didn’t approve the event in time.": "Admin didn’t approve the event in time.",
  "Something went wrong. Password cannot be changed right now.": "Something went wrong. Password cannot be changed right now.",
  "Something went wrong. File {{fileName}} couldn't be uploaded.": "Something went wrong. File {{fileName}} couldn't be uploaded.",
  "Something went wrong. The attachment couldn't be deleted.": "Something went wrong. The attachment couldn't be deleted.",
  "Your password has expired": "Your password has expired",
  "Social": "Social",
  "Telehealth": "Telehealth",
  "This event doesn’t have a description yet": "This event doesn’t have a description yet",
  "No Description Available": "No Description Available",
  "Medical group": "Medical group",
  "This conference has ended.": "This conference has ended.",
  "The event is not ready yet. Please try again later.": "The event is not ready yet. Please try again later.",
  "Sorry, we couldn’t determine the status of this event. Please try again later.": "Sorry, we couldn’t determine the status of this event. Please try again later.",
  "This event has been canceled by author": "This event has been canceled by author",
  "Event canceled": "Event canceled",
  "Canceled:": "Canceled:",
  "Change timezone": "Change timezone",
  "W{{weekNumber}}": "W{{weekNumber}}",
  "Go to today's date": "Go to today’s date,<br/>{{date}}",
  "Go to current month": "Go to current month,<br/>{{date}}",
  "Go to current week": "Go to current week,<br/>{{date}}",
  "Go to previous week": "Go to previous week,<br/>{{date}}",
  "Go to following week": "Go to following week,<br/>{{date}}",
  "Go to previous day": "Go to previous day,<br/>{{date}}",
  "Go to following day": "Go to following day,<br/>{{date}}",
  "Go to previous month": "Go to previous month,<br/>{{date}}",
  "Go to following month": "Go to following month,<br/>{{date}}",
  "There are currently no events for selected period": "There are currently no events for selected period",
  "Showing all invitations": "Showing all invitations",
  "Showing all upcoming declined invitations": "Showing all upcoming declined invitations",
  "All your invitations to upcoming events will appear here": "All your invitations to upcoming events will appear here",
  "No upcoming invitations": "No upcoming invitations",
  "Are you sure you want to report this kudo?": "Are you sure you want to report this kudo?",
  "Kudos to...": "Kudos to...",
  "No repeat": "No repeat",
  "Repeats daily": "Repeats daily",
  "Repeats weekly": "Repeats weekly",
  "Repeats monthly": "Repeats monthly",
  "Online": "Online",
  "going": "going",
  "No declined events": "No declined events",
  "If you decline an event, it will appear here": "If you decline an event, it will appear here",
  "Upcoming declined events": "Upcoming declined events",
  "Past declined events": "Past declined events",
  "Upcoming Invitations": "Upcoming Invitations",
  "Declined events": "Declined events",
  "Are you sure you want to report this kudo": "Are you sure you want to report this kudo?",
  "Are you sure you want to delete this kudo?": "Are you sure you want to delete this kudo?",
  "Unable to load user details.": "Unable to load user details.",
  "You cannot decline an event where you are the author": "You cannot decline an event where you are the author",
  "Passkeys": "Passkeys",
  "Create a passkey": "Create a passkey",
  "Something went wrong. The passkey couldn't be deleted.": "Something went wrong. The passkey couldn't be deleted.",
  "Something went wrong. The passkey couldn't be created.": "Something went wrong. The passkey couldn't be created.",
  "Passkey deleted successfully.": "Passkey successfully deleted.",
  "Passkey created successfully.": "Passkey created successfully.",
  "With passkeys on BigHeart, you can securely sign in using your fingerprint, face, screen lock, or security key—no password needed. Passkeys and security keys can also serve as an extra verification step when logging in with a password. Keep your screen locks private and security keys safe so only you can access your BigHeart account": "With passkeys on BigHeart, you can securely sign in using your fingerprint, face, screen lock, or security key—no password needed. Passkeys and security keys can also serve as an extra verification step when logging in with a password. Keep your screen locks private and security keys safe so only you can access your BigHeart account",
  "Delete the passkey?": "Delete the passkey?",
  "Deleting this passkey means you’ll need to login differently next time.": "Deleting this passkey means you’ll need to login differently next time.",
  "Send me the password": "Send me the password",
  "Log in and set up a passkey": "Log in and set up a passkey",
  "Log in with passkey": "Log in with passkey",
  "Log in with Your Passkey": "Log in with Your Passkey",
  "If you can’t use a passkey, you can get a one‑time password sent to your email instead.": "If you can’t use a passkey, you can get a one‑time password sent to your email instead.",
  "Use a passkey to log in with biometric authentication or your device&apos;s security. Passkeys are faster and more secure than passwords—and will be required soon.": "Use a passkey to log in with biometric authentication or your device&apos;s security. Passkeys are faster and more secure than passwords—and will be required soon.",
  "You&apos;ll sign in with a one-time password sent to your email. After you&apos;re logged in, you can create a passkey so next time you can log in with biometric authentication or your device&apos;s screen lock.": "You&apos;ll sign in with a one-time password sent to your email. After you&apos;re logged in, you can create a passkey so next time you can log in with biometric authentication or your device&apos;s screen lock.",
  "Passkeys are faster and more secure than passwords and protect you against phishing and other common attacks.": "Passkeys are faster and more secure than passwords and protect you against phishing and other common attacks.",
  "You can set up a passkey anytime in Account → Settings → Passkeys.": "You can set up a passkey anytime in Account → Settings → Passkeys.",
  "Send me the emial instead": "Send me the emial instead",
  "Authentication with passkey failed. Try again later.": "Authentication with passkey failed. Try again later.",
  "There are currently no events for today": "There are currently no events for today",
  "Publish": "Publish",
  "Mobile": "Mobile",
  "Download": "Download",
  "New": "New",
  "Updated": "Updated",
  "You canceled the passkey creation process": "You canceled the passkey creation process",
  "Passkey creation is not available on this device": "Passkey creation is not available on this device",
  "The passkey you're trying to create is already in use on this device": "The passkey you're trying to create is already in use on this device",
  "Passkey creation failed for an unknown reason": "Passkey creation failed for an unknown reason",
  "We are sad to see you go!": "We are sad to see you go!",
  "You have successfully unsubscribed, you will no longer receive this type of emails.": "You have successfully unsubscribed, you will no longer receive this type of emails.",
  "Step {{step}} of {{total}}": "Step {{step}} of {{total}}",
  "No medical group found": "No medical group found",
  "Failed to load medical group details. The telehealth visit request could not be created. Please try again later.": "Failed to load medical group details. The telehealth visit request could not be created. Please try again later.",
  "Calendar": "Calendar",
  "min": "min",
  "hr_one": "{{count}} hr",
  "hr_other": "{{count}} hrs",
  "Times are shown in your browser's timezone ({{timeZone}}, {{offset}})": "Times are shown in your browser's timezone ({{timeZone}}, {{offset}})",
  "Event over midnight: Event ends on {{date}} at {{time}} with duration of {{duration}}.": "<strong>Event over midnight:</strong> Event ends on {{date}} at {{time}} with duration of {{duration}}.",
  "Attach files": "Attach files",
  "Event will appear in Channels and become public. Anyone will be able to join.": "Event will appear in Channels and become public. Anyone will be able to join.",
  "Show event in Channels (Optional)": "Show event in Channels (Optional)",
  "Error: Date must be in the future": "Error: Date must be in the future",
  "Error: Starts is not a valid time": "Error: Starts is not a valid time",
  "Error: Starts must be in the future": "Error: Starts must be in the future",
  "Choose organization...": "Choose organization...",
  "Event created successfully.": "Event created successfully.",
  "Support for a single or bulk upload.": "Support for a single or bulk upload.",
  "Media cannot be uploaded, please try again later.": "Media cannot be uploaded, please try again later.",
  "Event attachments cannot be uploaded, please try again later.": "Event attachments cannot be uploaded, please try again later.",
  "Community": "Community",
  "Non-registered user": "Non-registered user",
  "Type user name, e-mail or community you want to invite": "Type user name, e-mail or community you want to invite",
  "Type user name or e-mail you want to invite. You can invite up to {{count}} people.": "Type user name or e-mail you want to invite. You can invite up to {{count}} people.",
  "You've reached the {{count}}-invitation limit for your role. Remove someone to add another.": "You've reached the {{count}}-invitation limit for your role. Remove someone to add another.",
  "Invalid option": "Invalid option",
  "Custom channels": "Custom channels",
  "Default channels": "Default channels",
  "Tags appear for organizations that are using custom channels": "Tags appear for organizations that are using custom channels",
  "Copy link for attendee": "Copy link for <strong>attendee</strong>",
  "Copy link for presenter": "Copy link for <strong>presenter</strong>",
  "QR code for attendee": "QR code for <strong>attendee</strong>",
  "QR code for presenter": "QR code for <strong>presenter</strong>",
  "Invite more": "Invite more",
  "Cancel event": "Cancel event",
  "Event canceled successfully": "Event canceled successfully",
  "Something went wrong. The event couldn’t be canceled.": "Something went wrong. The event couldn’t be canceled.",
  "Are you sure you want to cancel {{name}}?": "Are you sure you want to cancel {{name}}?",
  "Event type is not supported for editing": "Event type is not supported for editing",
  "Something went wrong. Event can't be edited right now. Try again later.": "Something went wrong. Event can't be edited right now. Try again later.",
  "Unable to generate invitation QR code.": "Unable to generate invitation QR code.",
  "Unable to generate invitation token.": "Unable to generate invitation token.",
  "Invite attendee via QR code": "Invite attendee via QR code",
  "Invite presenter via QR code": "Invite presenter via QR code",
  "Reminder created successfully.": "Reminder created successfully.",
  "Failed to create reminder.": "Failed to create reminder.",
  "Up to 64 participants total. Interactive mode: all can share camera and audio": "Up to 64 participants total. Interactive mode: all can share camera and audio",
  "Up to 64 admins/presenters with 1000 participants total. Presentation mode: Attendees can view, hear, chat, etc.": "Up to 64 admins/presenters with 1000 participants total. Presentation mode: Attendees can view, hear, chat, etc.",
  "Can view webinar and interact via chat, Q&A, polls, and handouts. Audio/video sharing only if enabled by admin.": "Can view webinar and interact via chat, Q&A, polls, and handouts. Audio/video sharing only if enabled by admin.",
  "Full control over webinar. Can manage all settings, record, end webinar, control attendee permissions, and share content.": "Full control over webinar. Can manage all settings, record, end webinar, control attendee permissions, and share content.",
  "Can share content (mic, webcam, files, screen) but cannot access host controls or manage other participants.": "Can share content (mic, webcam, files, screen) but cannot access host controls or manage other participants.",
  "Reminder name": "Reminder name",
  "Reminder details": "Reminder details",
  "Date and time": "Date and time",
  "Type user name or community you want to remind. You can remind up to {{count}} people.": "Type user name or community you want to remind. You can remind up to {{count}} people.",
  "Type user name you want to remind. You can remind up to {{count}} people.": "Type user name you want to remind. You can remind up to {{count}} people.",
  "Set reminder": "Set reminder",
  "Add people": "Add people",
  "People ({{invited}}/{{limit}})": "People ({{invited}}/{{limit}})",
  "Can not add {{communityName}} community ({{membersCount}} members). Only {{remainingSpots}} of {{limit}} spots left.": "Can't add '{{communityName}}' community ({{membersCount}} members). Only {{remainingSpots}} of {{limit}} spots left.",
  "You reached the limit of {{limit}} people. Remove some people, if you want to add new ones.": "You reached the limit of {{limit}} people. Remove some people, if you want to add new ones.",
  "Edit reminder": "Edit reminder",
  "Reminder edited successfully.": "Reminder edited successfully.",
  "Delete reminder": "Delete reminder",
  "Reminder deleted successfully.": "Reminder deleted successfully.",
  "Are you sure you want to delete {{name}} reminder?": "Are you sure you want to delete {{name}} reminder?",
  "Duplicate Reminder": "Duplicate Reminder",
  "Reminder duplicated successfully.": "Reminder duplicated successfully.",
  "Duplicate this reminder with everyone added?": "Duplicate this reminder with everyone added?",
  "Everyone currently added will get the duplicated reminder.": "Everyone currently added will get the duplicated reminder.",
  "The duplicated reminder won't include any people.": "The duplicated reminder won't include any people.",
  "Something went wrong. The reminder couldn’t be deleted.": "Something went wrong. The reminder couldn’t be deleted.",
  "People ({{count}})": "People ({{count}})",
  "Add people ({{invited}}/{{limit}})": "Add people ({{invited}}/{{limit}})",
  "All people": "All people",
  "Add more people": "Add more people",
  "Remove from reminder": "Remove from reminder",
  "Something went wrong. {{name}} couldn’t be removed from reminder": "Something went wrong. {{name}} couldn’t be removed from reminder",
  "{{name}} removed from reminder successfully": "{{name}} removed from reminder successfully",
  "You can add the user again at any time.": "You can add the user again at any time.",
  "Are you sure you want to remove {{name}} from this reminder?": "Are you sure you want to remove {{name}} from this reminder?",
  "Reminder has been reported to admins of your organization.": "Reminder has been reported to admins of your organization.",
  "Something went wrong. Please try again later.": "Something went wrong. Please try again later.",
  "Error": "Error",
  "Welcome to BigHeart's AI Knowledge Assistant! I can help you find information from internal documents — including policies, processes, team guides, and more. Ask me anything and I'll do my best to find the right answer for you.": "Welcome to BigHeart's AI Knowledge Assistant! I can help you find information from internal documents — including policies, processes, team guides, and more. Ask me anything and I'll do my best to find the right answer for you.",
  "Info: Always verify answers — AI responses may not be fully accurate": "Info: Always verify answers — AI responses may not be fully accurate",
  "Write a message": "Write a message",
  "AI Chat": "AI Chat",
  "AI Knowledge Assistant": "AI Knowledge Assistant",
  "{{count}} people": "{{count}} people",
  "Until {{ date, time }}": "Until {{ date, time }}",
  "private": "private",
  "public": "public",
  "secret": "secret",
  "Chat info": "Chat info",
  "Delete chat": "Delete chat",
  "Are you sure you want to delete this chat?": "Are you sure you want to delete this chat?",
  "Chat deleted successfully": "Chat deleted successfully",
  "Something went wrong. Chat couldn't be deleted.": "Something went wrong. Chat couldn't be deleted.",
  "Something went wrong. Chat couldn't be created.": "Something went wrong. Chat couldn't be created.",
  "Something went wrong. Message couldn't be sent.": "Something went wrong. Message couldn't be sent.",
  "Chat created successfully": "Chat created successfully",
  "Redirected to existing chat": "Redirected to existing chat",
  "Go to profile": "Go to profile",
  "Admin Console": "Admin Console",
  "No messages yet": "No messages yet",
  "No group messages": "No group messages",
  "No unread messages": "No unread messages",
  "Create a message to start a new conversation": "Create a message to start a new conversation",
  "Try refining your search terms or start a new conversation": "Try refining your search terms or start a new conversation",
  "Your group messages will appear here": "Your group messages will appear here",
  "Your unread messages will appear here": "Your unread messages will appear here",
  "Create a message": "Create a message",
  "You": "You",
  "Send a message ...": "Send a message ...",
  "{{fileName}} exceeds the {{fileSize}} MB limit. Nothing was added.": "{{fileName}} exceeds the {{fileSize}} MB limit. Nothing was added.",
  "{{count}} files exceed the {{fileSize}} MB limit. Nothing was added.": "{{count}} files exceed the {{fileSize}} MB limit. Nothing was added.",
  "Maximum {{count}} attachments per message. Nothing was added.": "Maximum {{count}} attachments per message. Nothing was added.",
  "Nothing was added: max {{count}} attachments, max {{fileSize}} MB per file.": "Nothing was added: max {{count}} attachments, max {{fileSize}} MB per file.",
  "To:": "To:",
  "Add members": "Add members",
  "Chat name": "Chat name",
  "Rename chat": "Rename chat",
  "Reset to default": "Reset to default",
  "Leave empty to name the chat after its participants": "Leave empty to name the chat after its participants",
  "Chat renamed successfully": "Chat renamed successfully",
  "Something went wrong. Chat couldn't be renamed.": "Something went wrong. Chat couldn't be renamed.",
  "Remove member": "Remove member",
  "Are you sure you want to remove <strong>{{memberName}}</strong> from this chat?": "Are you sure you want to remove <strong>{{memberName}}</strong> from this chat?",
  "Member removed successfully": "Member removed successfully",
  "Something went wrong. Member couldn't be removed.": "Something went wrong. Member couldn't be removed.",
  "Member(s) added successfully": "Member(s) added successfully",
  "Something went wrong. Member(s) couldn't be added.": "Something went wrong. Member(s) couldn't be added.",
  "Search members": "Search members",
  "You must select at least 1 member to add.": "You must select at least 1 member to add.",
  "Selected": "Selected",
  "Add": "Add",
  "Show search": "Show search",
  "Hide search": "Hide search",
  "There are no messages yet. Send a message to start a conversation.": "There are no messages yet. Send a message to start a conversation.",
  "chatNewIncomingMessages_one": "{{count}} new message",
  "chatNewIncomingMessages_other": "{{count}} new messages",
  "Cannot generate link with login token": "Cannot generate link with login token",
  "photo_one": "Photo",
  "photo_other": "{{count}} photos",
  "video_one": "Video",
  "video_other": "{{count}} videos",
  "file_one": "File",
  "file_other": "{{count}} files",
  "Multiple attachments": "Multiple attachments",
  "Visibility": "Visibility",
  "You can choose multiple options": "You can choose multiple options",
  "Date of birth is not valid": "Date of birth is not valid",
  "Email me a login link": "Email me a login link",
  "Error: Description is required": "Error: Description is required",
  "Number of days in month is not valid": "Number of days in month is not valid"
}
